import Locator from './locator'
import { Carousel_CoreInit, Scrollbar } from '../core'
import { carouselConfigs } from './carousel-config'
import { createBundleDropdowns } from './bundle-dropdowns'
const $tpl_favorite_button = $('#tpl-favorite-button')
const favorites = {
  id: undefined,
  favorite_items: [],
  favorite_lists: {}, // For logged-in users: { list_uid: [content_uid, ...] }
  list_metadata: {}, // For logged-in users: { list_uid: { title, slug, public, description, ... } }
  history_items: undefined,
  history_html: undefined,

  stringRandom(length) {
    const characters = 'abdefil012345679'
    let result = ''
    const charactersLength = characters.length
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength))
    }
    return result
  },

  generateFavoritesUid() {
    let string = ''
    while (string.length < 32) {
      string += this.stringRandom(Math.floor(Math.random() * (16 - 4 + 1)) + 4)
      string += '-'
    }
    string = string.slice(0, -1)
    if (string.length < 32) {
      string += this.stringRandom(1)
    }
    return string.substring(0, 32).toLowerCase()
  },

  setCookie(name, value, days) {
    let expires = ""
    if (days) {
      const date = new Date()
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
      expires = "; expires=" + date.toUTCString()
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/; SameSite=Lax"
  },

  loadFavorites() {
    if (!this.id) return

    $.ajax({
      url: '/favorites/',
      method: 'POST',
      data: {
        'action': 'get_favorites_list',
        'list_uid': this.id,
        'language': gourmetsauvage_params.LANGUAGE,
      },
      success: (response) => {
        try {
          const data = typeof response === 'string' ? JSON.parse(response) : response

          if (data.list_uid && data.list_uid !== this.id) {
            this.id = data.list_uid
            localStorage.setItem('favorites_id', this.id)
            this.setCookie('favorites_list_uid', this.id, 365)
          }
          this.favorite_items = data.items || []
          this.buttons()

          // Now that favorites are loaded, initialize history, hit tracking, and page
          this.history()
          this.hit()
          this.page()
          this.updateFavoriteCount()
        } catch(e) {
          this.favorite_items = []
        }
      },
    })
  },

  loadAllUserLists(callback) {
    // For logged-in users: load all lists and populate favorite_lists
    $.ajax({
      url: '/favorites/',
      method: 'POST',
      data: {
        'action': 'get_user_lists',
        'language': gourmetsauvage_params.LANGUAGE,
      },
      success: (response) => {
        try {
          const data = typeof response === 'string' ? JSON.parse(response) : response

          if (data.success && data.lists && data.lists.length > 0) {
            let listsLoaded = 0
            const totalLists = data.lists.length

            // Load items for each list
            data.lists.forEach((list) => {
              $.ajax({
                url: '/favorites/',
                method: 'POST',
                data: {
                  'action': 'get_favorites_list',
                  'list_uid': list.uid,
                  'language': gourmetsauvage_params.LANGUAGE,
                },
                success: (listResponse) => {
                  try {
                    const listData = typeof listResponse === 'string' ? JSON.parse(listResponse) : listResponse
                    const items = listData.items || []

                    // Store items for this list
                    this.favorite_lists[list.uid] = items

                    // Add items to favorite_items (avoiding duplicates)
                    items.forEach((item) => {
                      if (!this.favorite_items.includes(item)) {
                        this.favorite_items.push(item)
                      }
                    })

                    listsLoaded++

                    // When all lists are loaded, execute callback
                    if (listsLoaded === totalLists && callback) {
                      callback()
                    }
                  } catch(e) {
                    console.error('Error parsing list data:', e)
                    listsLoaded++
                    if (listsLoaded === totalLists && callback) {
                      callback()
                    }
                  }
                },
                error: (error) => {
                  console.error('Error loading list items:', error)
                  listsLoaded++
                  if (listsLoaded === totalLists && callback) {
                    callback()
                  }
                }
              })
            })
          } else {
            // No lists, just call callback
            if (callback) callback()
          }
        } catch(e) {
          console.error('Error loading user lists:', e)
          if (callback) callback()
        }
      },
      error: (error) => {
        console.error('Error loading user lists:', error)
        if (callback) callback()
      }
    })
  },

  add(content_uid, list_uid) {
    // Always add to main favorite_items array
    if (!this.favorite_items.includes(content_uid)) {
      this.favorite_items.push(content_uid)
    }

    // If list_uid provided (logged-in users), also add to that specific list
    if (list_uid) {
      if (!this.favorite_lists[list_uid]) {
        this.favorite_lists[list_uid] = []
      }
      if (!this.favorite_lists[list_uid].includes(content_uid)) {
        this.favorite_lists[list_uid].push(content_uid)
      }
    }
  },

  remove(content_uid, list_uid) {
    // If list_uid provided, remove from that specific list
    if (list_uid) {
      if (this.favorite_lists[list_uid]) {
        this.favorite_lists[list_uid] = this.favorite_lists[list_uid].filter(item => item !== content_uid)
      }

      // Check if item still exists in any other list
      const stillInOtherLists = Object.values(this.favorite_lists).some(list => list.includes(content_uid))
      if (!stillInOtherLists) {
        // Remove from favorite_items only if not in any list
        this.favorite_items = this.favorite_items.filter(item => item !== content_uid)
      }
    } else {
      // No list_uid provided (anonymous users) - remove from everything
      this.favorite_items = this.favorite_items.filter(item => item !== content_uid)
    }
  },

  has(content_uid, list_uid) {
    const isLoggedIn = $('html').hasClass('--logged-in')

    // For anonymous users, always check favorite_items
    if (!isLoggedIn) {
      return this.favorite_items.includes(content_uid)
    }

    // For logged-in users:
    // If list_uid provided, check that specific list
    if (list_uid) {
      return this.favorite_lists[list_uid] && this.favorite_lists[list_uid].includes(content_uid)
    }
    // Otherwise check favorite_items (general check)
    return this.favorite_items.includes(content_uid)
  },

  updateFavoriteCount() {
    const count = $.mlmi.favorites.favorite_items.length
    $('.top-menu__item--wishlist-page-link .top-menu__link').attr('data-count', count)
  },

  initScrollbar(menuContent, scrollbarRef) {
    const existingScrollbar = scrollbarRef || menuContent.data('scrollbar-instance')

    // If scrollbar already exists, just update it
    if (existingScrollbar && typeof existingScrollbar.update === 'function') {
      existingScrollbar.update()
      return existingScrollbar
    }

    // Otherwise, create new scrollbar if needed
    const maxHeight = parseInt(menuContent.css('max-height'))
    if (menuContent[0].scrollHeight > maxHeight) {
      menuContent.css('height', maxHeight + 'px')
      const menuContentElement = menuContent[0]
      if (!menuContentElement.id) {
        menuContentElement.id = 'favorite-menu-content-' + Math.random().toString(36).substr(2, 9)
      }
      const newScrollbar = new Scrollbar('#' + menuContentElement.id, {
        direction: 'vertical',
        desktop: true,
        mobile: true,
      })
      menuContent.data('scrollbar-instance', newScrollbar)
      return newScrollbar
    }
    return null
  },

  createNewList(listName, callback) {
    // Reusable function to create a new list
    if (listName.length >= 1) {
      $.ajax({
        url: '/favorites/',
        method: 'POST',
        data: {
          'action': 'create_list',
          'title': listName,
          'language': gourmetsauvage_params.LANGUAGE,
        },
        success: (response) => {
          try {
            const data = typeof response === 'string' ? JSON.parse(response) : response

            if (data.success && data.list) {
              // Add to all .favorite-menu__list on the page
              $('.favorite-menu__list').each(function() {
                const menuList = $(this)
                const menuContent = menuList.closest('.favorite-menu__content')
                const isWishlistSwitcher = menuContent.closest('.wishlist-list__switch-list').length > 0

                if (isWishlistSwitcher) {
                  // Create wishlist switcher item
                  const newItem = $('<button class="wishlist-list__switch-list__item" data-list-uid="' + data.list.uid + '">' + listName + '</button>')

                  // Add click handler for switcher
                  newItem.on('click', function() {
                    const listUid = $(this).attr('data-list-uid')
                    const listTitle = $(this).text()

                    // Update toggle button text
                    $('.wishlist-list__switch-list__toggle span').text(listTitle)

                    // Update sidebar title
                    $('.wishlist-sidebar__title').text(listTitle)

                    // Empty the grid first
                    $('.wishlist-grid').empty()

                    // Update the wishlist-grid data-list-id
                    $('.wishlist-grid').attr('data-list-id', listUid)

                    // Update UI based on list status (public/private)
                    $.mlmi.favorites.updateListUI(listUid)

                    // Update browser URL
                    $.mlmi.favorites.updateBrowserURL(listUid)

                    // Reload the page with the new list
                    $('.wishlist-grid').FavoritesPage()
                  })

                  menuList.prepend(newItem)
                } else {
                  // Create favorite menu item
                  const newItem = $('<button class="favorite-menu__item" data-list-uid="' + data.list.uid + '"><div class="favorite-menu__name"><span>' + listName + '</span></div></button>')
                  menuList.prepend(newItem)
                  newItem.FavoriteButton()
                }

                $.mlmi.favorites.initScrollbar(menuContent)
              })

              // Update favorite_lists with empty array for this new list
              this.favorite_lists[data.list.uid] = []

              // Store metadata for the new list
              this.list_metadata[data.list.uid] = {
                title: data.list.title || listName,
                slug: data.list.slug || null,
                public: data.list.public || 0,
                description: data.list.description || '',
                item_count: 0
              }

              if (callback) {
                callback(data.list)
              }
            } else if (data.error) {
              console.error('Error creating list:', data.error)
            }
          } catch(e) {
            console.error('Error parsing response:', e)
          }
        },
        error: (error) => {
          console.error('Error creating list:', error)
        }
      })
    }
  },

  showModal(options = {}) {
    const {
      title = '',
      content = '',
      ctaText = '',
      ctaIcon = '',
      onCta = null,
      secondaryCtaText = '',
      onSecondaryCta = null,
      onContentReady = null,
      modalClass = ''
    } = options

    // Create modal structure
    const overlay = $('<div class="wishlist-popup-overlay"></div>')
    const modal = $('<div class="wishlist-popup"></div>')
    const header = $('<div class="wishlist-popup__header"></div>')
    const titleElement = $('<h3 class="wishlist-popup__title"></h3>').text(title)
    const closeButton = $('<button class="wishlist-popup__close" aria-label="Close"></button>')
    const contentContainer = $('<div class="wishlist-popup__content"></div>')
    const footer = $('<div class="wishlist-popup__footer"></div>')
    const ctaButton = $('<button class="wishlist-popup__cta"></button>')

    // Add icon if provided
    if (ctaIcon) {
      ctaButton.append('<i class="' + ctaIcon + '"></i>')
    }
    ctaButton.append(ctaText)

    // Add custom class if provided
    if (modalClass) {
      modal.addClass(modalClass)
    }

    // Assemble modal
    header.append(titleElement).append(closeButton)

    // Handle content (string or node)
    if (typeof content === 'string') {
      contentContainer.html(content)
    } else {
      contentContainer.append(content)
    }

    // Append primary CTA button first (left aligned)
    footer.append(ctaButton)

    // Add secondary button if provided (right of primary)
    if (secondaryCtaText) {
      const secondaryCtaButton = $('<button class="wishlist-popup__cta wishlist-popup__cta--secondary"></button>').text(secondaryCtaText)
      footer.append(secondaryCtaButton)

      if (onSecondaryCta) {
        secondaryCtaButton.on('click', (e) => {
          e.preventDefault()
          onSecondaryCta(closeModal)
        })
      }
    }
    modal.append(header).append(contentContainer).append(footer)

    // Close function
    const closeModal = () => {
      overlay.fadeOut(200, function() {
        overlay.remove()
      })
    }

    // Track mousedown position for click-outside detection
    let mousedownTarget = null

    // Bind events
    closeButton.on('click', (e) => {
      e.preventDefault()
      closeModal()
    })

    // Track where mousedown happens
    overlay.on('mousedown', (e) => {
      mousedownTarget = e.target
    })

    // Only close if both mousedown and mouseup happen on overlay
    overlay.on('mouseup', (e) => {
      if ($(e.target).hasClass('wishlist-popup-overlay') &&
          $(mousedownTarget).hasClass('wishlist-popup-overlay')) {
        closeModal()
      }
      mousedownTarget = null
    })

    if (onCta) {
      ctaButton.on('click', (e) => {
        e.preventDefault()
        onCta(closeModal)
      })
    }

    // Append to body
    overlay.append(modal)
    $('body').append(overlay)

    // Call onContentReady after content is inserted
    if (onContentReady) {
      onContentReady(contentContainer)
    }

    // Show modal with fade in
    overlay.hide().fadeIn(200)

    return {
      close: closeModal,
      overlay: overlay,
      modal: modal,
      contentContainer: contentContainer
    }
  },

  buttons(scope) {
    if (scope == undefined) {
      scope = document
    }

    const isLoggedIn = $('html').hasClass('--logged-in')

    $(scope).find('mlmi-marker').not('.header__search-bar mlmi-marker').each(function() {
      // Check if this marker already has a favorite button next to it
      if ($(this).next('.favorite-button').length > 0) {
        // Button already exists, just update its state
        let existingButton = $(this).next('.favorite-button')
        let uid = $(this).data('content-uid')

        if (isLoggedIn) {
          // For logged-in users: update each menu item based on its specific list
          let menuItems = existingButton.find('.favorite-menu__item')
          menuItems.each(function() {
            let listUid = $(this).attr('data-list-uid')
            if (listUid && $.mlmi.favorites.has(uid, listUid)) {
              $(this).attr('aria-pressed', 'true')
            } else {
              $(this).attr('aria-pressed', 'false')
            }
          })

          // Update toggle button based on menu items (not favorite_items)
          const anyPressed = existingButton.find('.favorite-menu__item[aria-pressed="true"]').length > 0
          if (anyPressed) {
            existingButton.attr('aria-pressed', 'true')
            existingButton.find('.favorite-button__toggle span').text(gourmetsauvage_params.ADDED_TO_FAVORITES)
          } else {
            existingButton.attr('aria-pressed', 'false')
            existingButton.find('.favorite-button__toggle span').text(gourmetsauvage_params.ADD_TO_FAVORITES)
          }
        } else {
          // For anonymous users: update toggle button directly
          if ($.mlmi.favorites.has(uid)) {
            existingButton.attr('aria-pressed', 'true')
            existingButton.find('.favorite-button__toggle').attr('aria-pressed', 'true')
            existingButton.find('.favorite-button__toggle span').text(gourmetsauvage_params.ADDED_TO_FAVORITES)
          } else {
            existingButton.attr('aria-pressed', 'false')
            existingButton.find('.favorite-button__toggle').attr('aria-pressed', 'false')
            existingButton.find('.favorite-button__toggle span').text(gourmetsauvage_params.ADD_TO_FAVORITES)
          }
        }
        return
      }

      // Create new button
      var $new_favorite_button = $($tpl_favorite_button.html())
      $(this).after($new_favorite_button)

      if (isLoggedIn) {
        // Logged-in users: menu with multiple lists
        let uid = $(this).data('content-uid')

        $new_favorite_button.find('.favorite-menu__item').FavoriteButton()
        $new_favorite_button.find('button, input').click(function() {
          return false;
        })
        // Initialize toggle functionality to open menu
        $new_favorite_button.find('.favorite-button__toggle').FavoriteMenuToggle()

        // Set initial state of toggle button based on whether item is in ANY list
        if ($.mlmi.favorites.has(uid)) {
          $new_favorite_button.attr('aria-pressed', 'true')
          $new_favorite_button.find('.favorite-button__toggle span').text(gourmetsauvage_params.ADDED_TO_FAVORITES)
        } else {
          $new_favorite_button.attr('aria-pressed', 'false')
          $new_favorite_button.find('.favorite-button__toggle span').text(gourmetsauvage_params.ADD_TO_FAVORITES)
        }
      } else {
        // Anonymous users: direct toggle behavior
        $new_favorite_button.find('.favorite-button__toggle').FavoriteButton()
        // Hide the menu for anonymous users
        $new_favorite_button.find('.favorite-button__menu').remove()
      }
    })
  },

  updateItemPrice($item) {
    // Update individual item price based on quantity
    const $priceDisplay = $item.find('.cart-item__unit-price')
    const $qtyInput = $item.find('input.qty')

    if ($priceDisplay.length && $qtyInput.length) {
      const unitPrice = parseFloat($priceDisplay.attr('data-unit-price')) || 0
      const quantity = parseInt($qtyInput.val()) || 1
      const totalPrice = unitPrice * quantity

      // Update display
      if (gourmetsauvage_params.LANGUAGE === 'fr') {
        $priceDisplay.text(totalPrice.toFixed(2).replace('.', ',') + ' $')
      } else {
        $priceDisplay.text('$' + totalPrice.toFixed(2))
      }
    }
  },

  updateWishlistSummary() {
    let totalItems = 0 // Sum of all quantities
    let totalValue = 0
    let cardCount = 0 // Number of cards (for visual layout)

    /* Calculate totals based on quantity × unit price */
    $('.card-wishlist').each(function() {
      const $item = $(this)
      const $priceDisplay = $item.find('.cart-item__unit-price')
      const $qtyInput = $item.find('input.qty')

      if ($priceDisplay.length && $qtyInput.length) {
        const unitPrice = parseFloat($priceDisplay.attr('data-unit-price')) || 0
        const quantity = parseInt($qtyInput.val()) || 1

        totalItems += quantity
        totalValue += (unitPrice * quantity)
        cardCount++ // Count each card regardless of quantity
      }
    })

    /* Update wishlist summary count */
    let countText = ''
    if (gourmetsauvage_params.LANGUAGE === 'fr') {
      countText = totalItems + (totalItems <= 1 ? ' produit' : ' produits')
    } else {
      countText = totalItems + (totalItems === 1 ? ' product' : ' products')
    }
    $('.wishlist-summary__item-count').text(countText)

    /* Update wishlist summary value */
    let valueText = ''
    if (gourmetsauvage_params.LANGUAGE === 'fr') {
      valueText = 'Valeur de ' + totalValue.toFixed(2).replace('.', ',') + '$'
    } else {
      valueText = 'Value of $' + totalValue.toFixed(2)
    }
    $('.wishlist-summary__value').text(valueText)

    // Apply --less-than-10 class based on number of cards, not total quantity
    if (cardCount < 10) {
      $('.wishlist-list').addClass('--less-than-10');
    } else {
      $('.wishlist-list').removeClass('--less-than-10');
    }
  },

  updateListUI(listUid) {
    // Update UI elements based on list public/private status
    const metadata = this.list_metadata[listUid]
    if (!metadata) return

    const isPublic = metadata.public == 1 || metadata.public === true

    // Update public badge under title
    if (isPublic) {
      if (!$('.wishlist-sidebar__public-badge').length) {
        $('<p class="wishlist-sidebar__public-badge">' + (gourmetsauvage_params.WISHLIST_PUBLIC_BADGE || 'Liste publique') + '</p>').insertAfter('.wishlist-sidebar__title')
      }
    } else {
      $('.wishlist-sidebar__public-badge').remove()
    }

    // Update "Make private" button in actions (only in sidebar, not below the list)
    const makePrivateBtn = $('.js-wishlist-make-private')
    if (isPublic) {
      if (!makePrivateBtn.length) {
        const btn = $('<button class="wishlist-sidebar__action-link js-wishlist-make-private">' + (gourmetsauvage_params.WISHLIST_MAKE_PRIVATE || 'Rendre la liste privée') + '</button>')
        $('.wishlist-sidebar .wishlist-sidebar__actions').append(btn)
      }
    } else {
      makePrivateBtn.remove()
    }

    // Update share button state and reinitialize
    $('.wishlist-share').each(function() {
      const $shareContainer = $(this)
      $shareContainer.attr('data-is-public', isPublic ? '1' : '0')
      $.mlmi.favorites.initializeShareButton($shareContainer)
    })

    // Update container background
    if (isPublic) {
      $('.wishlist-list__container').addClass('wishlist-list__container--public')
    } else {
      $('.wishlist-list__container').removeClass('wishlist-list__container--public')
    }

    // Update notes title
    const notesTitle = $('.wishlist-sidebar__notes__title')
    if (notesTitle.length) {
      if (isPublic) {
        notesTitle.text(gourmetsauvage_params.WISHLIST_NOTES_PUBLIC || 'Notes (visible lorsque partagée)')
      } else {
        notesTitle.text(gourmetsauvage_params.WISHLIST_NOTES_PRIVATE || 'Notes personnelles')
      }
    }

    // Load notes/description for this list
    const notesTextarea = $('.wishlist-sidebar__notes__textarea')
    if (notesTextarea.length) {
      notesTextarea.val(metadata.description || '')
    }
  },

  getShareURL() {
    // Get the proper share URL for the current list
    const currentListUid = $('.wishlist-grid').attr('data-list-id')
    const metadata = this.list_metadata[currentListUid]

    if (!metadata) return window.location.href

    const isPublic = metadata.public == 1 || metadata.public === true

    if (isPublic && metadata.slug) {
      // Build full URL with UID and slug: /liste-de-souhaits/{uid}/{slug}/
      const lang = gourmetsauvage_params.LANGUAGE || 'fr'
      const path = lang === 'en'
        ? '/wishlist/' + currentListUid + '/' + metadata.slug + '/'
        : '/liste-de-souhaits/' + currentListUid + '/' + metadata.slug + '/'
      return window.location.origin + path
    }

    return window.location.href
  },

  initializeShareButton($shareContainer) {
    // Initialize share button based on its public/private state
    if (!$shareContainer || !$shareContainer.length) return

    const isPublic = $shareContainer.attr('data-is-public') === '1'

    // Remove all existing event handlers and data
    $shareContainer.off()
    $shareContainer.find('.share-button').off()
    $shareContainer.find('.share__action').off()
    $shareContainer.removeData('share')
    $shareContainer.attr('aria-expanded', 'false')

    if (isPublic) {
      // Update share URLs before initializing
      const shareUrl = $.mlmi.favorites.getShareURL()
      const currentListTitle = $('.wishlist-sidebar__title').text() || document.title

      // Update social media links
      $shareContainer.find('.share__action--facebook').attr('href',
        'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(shareUrl) + '&t=' + encodeURIComponent(currentListTitle))
        .attr('onclick',
        "window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent('" + shareUrl + "') + '&t=' + encodeURIComponent('" + currentListTitle + "'), 'facebook_sharer', 'width=550,height=400'); return false;")

      $shareContainer.find('.share__action--twitter').attr('href',
        'https://x.com/intent/post?source=' + encodeURIComponent(shareUrl) + '&text=' + encodeURIComponent(currentListTitle))
        .attr('onclick',
        "window.open('https://twitter.com/intent/tweet?text=' + encodeURIComponent('" + currentListTitle + "') + ':%20' + encodeURIComponent('" + shareUrl + "'), 'twitter_sharer', 'width=550,height=400'); return false;")

      $shareContainer.find('.share__action--linkedin').attr('href',
        'http://www.linkedin.com/shareArticle?mini=true&url=' + encodeURIComponent(shareUrl) + '&title=' + encodeURIComponent(currentListTitle) + '&summary=&source=' + encodeURIComponent(shareUrl))
        .attr('onclick',
        "window.open('http://www.linkedin.com/shareArticle?mini=true&url=' + encodeURIComponent('" + shareUrl + "') + '&title=' + encodeURIComponent('" + currentListTitle + "'), 'linkedin_sharer', 'width=550,height=400'); return false;")

      $shareContainer.find('.share__action--mail').attr('href',
        'mailto:?subject=' + encodeURIComponent(currentListTitle) + '&body=' + encodeURIComponent(shareUrl))

      // Initialize normal share plugin for public lists
      $shareContainer.Share()

      // Replace copy link handler to use correct URL (not hash)
      $shareContainer.find('.share__action--copy-link').off('click').on('click', function() {
        $(this).width($(this).width())
        $(this).find('textarea').val(shareUrl).focus().select()
        document.execCommand("Copy")
        $(this).find('span').text(gourmetsauvage_params.COPIED_LINK).addClass('visible')
        setTimeout(function() {
          $shareContainer.find('.share__action--copy-link span').removeClass('visible')
        }, 2000)
        return false
      })
    }
    // For private lists, the event handler is set up globally with event delegation
  },

  updateBrowserURL(listUid) {
    // Update browser URL hash to reflect current list
    const metadata = this.list_metadata[listUid]
    if (!metadata) return

    const isPublic = metadata.public == 1 || metadata.public === true
    let hash

    if (isPublic && metadata.slug) {
      // Public list: use UID/slug as hash
      hash = '#' + listUid + '/' + metadata.slug
    } else {
      // Private list: use UID as hash
      hash = '#' + listUid
    }

    // Update hash without adding to history
    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', hash)
    } else {
      window.location.hash = hash
    }
  },

  /* ============================================================================
   * LIST CONFIGURATION PERSISTENCE
   * Save and restore user selections (quantities, variations, bundle options)
   * ============================================================================ */

  /**
   * Build configuration object from all wishlist items
   * @returns {Object} Configuration keyed by product_id
   */
  buildListConfig() {
    const config = {}

    $('.card-wishlist').each(function() {
      const $card = $(this)
      const $marker = $card.find('.mlmi-marker')
      const contentUid = $marker.data('content-uid')

      if (!contentUid) return

      // Extract product ID from add-to-cart button
      const $addButton = $card.find('.add_to_cart_button')
      const productId = $addButton.data('product_id')

      if (!productId) return

      const itemConfig = {}

      // 1. Quantity
      const $qtyInput = $card.find('input.qty')
      if ($qtyInput.length) {
        itemConfig.quantity = parseInt($qtyInput.val()) || 1
      }

      // 2. Variable product variations
      const $variations = $card.find('.card-wishlist__variations')
      if ($variations.length) {
        itemConfig.variations = {}
        $variations.find('select').each(function() {
          const $select = $(this)
          const attrName = $select.data('attribute-name')
          const value = $select.val()
          if (attrName && value) {
            itemConfig.variations[attrName] = value
          }
        })

        // Also save the variation_id if one is selected
        const $addButton = $card.find('.add_to_cart_button')
        const variationId = $addButton.data('variation-id') || $addButton.attr('data-variation-id')
        if (variationId && variationId !== '0' && variationId !== 0) {
          itemConfig.variation_id = parseInt(variationId)
        }
      }

      // 3. Bundle options
      const $bundleData = $card.find('.card-wishlist__bundle-data')
      if ($bundleData.length) {
        itemConfig.bundle_options = {}
        $bundleData.find('input[name^="bundle_selected_optional_"]').each(function() {
          const $checkbox = $(this)
          if ($checkbox.is(':checked')) {
            itemConfig.bundle_options[$checkbox.attr('name')] = '1'
          }
        })
      }

      config[productId] = itemConfig
    })

    return config
  },

  /**
   * Save list configuration to database (debounced)
   */
  saveListConfigDebounced: null,

  saveListConfig() {
    // Clear existing timeout
    if ($.mlmi.favorites.saveListConfigDebounced) {
      clearTimeout($.mlmi.favorites.saveListConfigDebounced)
    }

    // Debounce: wait 500ms after last change
    $.mlmi.favorites.saveListConfigDebounced = setTimeout(() => {
      const config = $.mlmi.favorites.buildListConfig()

      // Get current list UID from the displayed wishlist grid
      const listUid = $('.wishlist-grid').attr('data-list-id')

      if (!listUid) {
        console.warn('Cannot save config: no list UID found in .wishlist-grid[data-list-id]')
        return
      }

      // Send to backend
      $.ajax({
        url: '/favorites/',
        method: 'POST',
        data: {
          action: 'save_list_config',
          list_uid: listUid,
          items_config: JSON.stringify(config),
          language: gourmetsauvage_params.LANGUAGE
        },
        success: (response) => {
          // saved
        },
        error: (xhr, status, error) => {
          console.error('Failed to save list config:', error)
        }
      })
    }, 500)
  },

  /**
   * Apply saved configuration to wishlist items
   * @param {Object} config - Configuration object keyed by product_id
   */
  applyListConfig(config) {
    if (!config || typeof config !== 'object') return

    $('.card-wishlist').each(function() {
      const $card = $(this)
      const $addButton = $card.find('.add_to_cart_button')
      const productId = String($addButton.data('product_id'))

      if (!productId || !config[productId]) return

      const itemConfig = config[productId]

      // 1. Apply quantity
      if (itemConfig.quantity) {
        const $qtyInput = $card.find('input.qty')
        if ($qtyInput.length) {
          $qtyInput.val(itemConfig.quantity).trigger('change')
        }
      }

      // 2. Apply variable product variations
      if (itemConfig.variations) {
        const $variations = $card.find('.card-wishlist__variations')
        if ($variations.length) {
          Object.keys(itemConfig.variations).forEach(attrName => {
            const value = itemConfig.variations[attrName]
            const $select = $variations.find(`select[data-attribute-name="${attrName}"]`)
            if ($select.length) {
              $select.val(value).trigger('change')
            }
          })
        }
      }

      // 3. Apply bundle options
      if (itemConfig.bundle_options) {
        const $bundleData = $card.find('.card-wishlist__bundle-data')
        if ($bundleData.length) {
          // First uncheck all
          $bundleData.find('input[name^="bundle_selected_optional_"]').prop('checked', false)

          // Then check the ones in config
          Object.keys(itemConfig.bundle_options).forEach(checkboxName => {
            const $checkbox = $bundleData.find(`input[name="${checkboxName}"]`)
            if ($checkbox.length) {
              $checkbox.prop('checked', true)
            }
          })

          // Trigger bundle dropdown update to sync UI
          const $bundleDropdowns = $card.find('.card-wishlist__bundle-dropdowns select')
          if ($bundleDropdowns.length) {
            $bundleDropdowns.each(function() {
              const $dropdown = $(this)
              const $options = $dropdown.find('option')

              // Detect if this is Toggle mode (has 'avec'/'sans') or Radio mode (has numeric IDs)
              const hasToggleOptions = $options.filter('[value="avec"]').length > 0

              if (hasToggleOptions) {
                // TOGGLE MODE: Check if any checkbox is checked
                const anyChecked = $bundleData.find('input[name^="bundle_selected_optional_"]').is(':checked')
                $dropdown.val(anyChecked ? 'avec' : 'sans').trigger('change')
              } else {
                // RADIO MODE: Find which option's checkbox is checked
                $options.each(function() {
                  const optionValue = $(this).val()
                  if (optionValue !== 'none') {
                    const $checkbox = $bundleData.find(`input[name="bundle_selected_optional_${optionValue}"]`)
                    if ($checkbox.length && $checkbox.is(':checked')) {
                      $dropdown.val(optionValue).trigger('change')
                    }
                  }
                })
              }
            })
          }
        }
      }
    })
  },

  handleVariationSelection($card) {
    const $variations = $card.find('.card-wishlist__variations')
    if (!$variations.length) return

    const productId = $variations.data('product-id')
    const $variationsDataScript = $card.find('.variations-data[data-product-id="'+productId+'"]')

    if (!$variationsDataScript.length) return

    const variationsData = JSON.parse($variationsDataScript.text())
    const $selects = $variations.find('select')
    const $addButton = $card.find('.add_to_cart_button')
    const $priceDisplay = $card.find('.cart-item__unit-price')

    // Listen to select changes
    $selects.on('change', () => {
      const selectedAttributes = {}
      let allSelected = true

      // Collect selected attributes
      $selects.each(function() {
        const value = $(this).val()
        const attrName = $(this).data('attribute-name')

        if (value) {
          // Normalize to lowercase for comparison
          selectedAttributes['attribute_' + attrName.toLowerCase()] = value.toLowerCase()
        } else {
          allSelected = false
        }
      })

      // Find matching variation
      if (allSelected) {
        const matchingVariation = variationsData.find(variation => {
          return Object.keys(selectedAttributes).every(attr => {
            const variationValue = variation.attributes[attr] ? variation.attributes[attr].toLowerCase() : ''
            return variationValue === selectedAttributes[attr]
          })
        })

        if (matchingVariation) {
          // Update variation_id on button
          $addButton.data('variation-id', matchingVariation.variation_id)
          $addButton.attr('data-variation-id', matchingVariation.variation_id)

          // Update unit price data attribute
          const price = matchingVariation.display_price
          $priceDisplay.attr('data-unit-price', price)

          // Update price display (multiplied by quantity)
          if ($.mlmi && $.mlmi.favorites && $.mlmi.favorites.updateItemPrice) {
            $.mlmi.favorites.updateItemPrice($card)
          }

          // Update wishlist summary
          if ($.mlmi && $.mlmi.favorites && $.mlmi.favorites.updateWishlistSummary) {
            $.mlmi.favorites.updateWishlistSummary()
          }
        }
      } else {
        // Reset if not all selected
        $addButton.data('variation-id', 0)
        $addButton.attr('data-variation-id', 0)
      }
    })
  },

  initializeBundleDropdowns($card) {
    const $bundleData = $card.find('.card-wishlist__bundle-data')
    if (!$bundleData.length) return

    const productId = $bundleData.data('product-id')
    const $bundleCustomDataScript = $card.find('.bundle-custom-data[data-product-id="'+productId+'"]')

    if (!$bundleCustomDataScript.length) return

    // Load bundle custom data into window for this product
    const bundleCustomData = JSON.parse($bundleCustomDataScript.text())
    window.bundleCustomData = bundleCustomData

    // Create dropdown container within the card
    let $dropdownContainer = $card.find('.card-wishlist__bundle-dropdowns')
    if (!$dropdownContainer.length) {
      $dropdownContainer = $('<div class="card-wishlist__bundle-dropdowns"></div>')
      // Insert after the title or at the beginning of the card
      const $afterTitle = $card.find('.card-wishlist__title, .card-wishlist__header')
      if ($afterTitle.length) {
        $afterTitle.after($dropdownContainer)
      } else {
        $card.prepend($dropdownContainer)
      }
    }

    const $priceDisplay = $card.find('.cart-item__unit-price')
    const basePrice = parseFloat($priceDisplay.data('unit-price'))

    // Create bundle dropdowns with price update callback
    // Use 'simple' template for wishlist cards (matches variable product variations)
    const updateBundlePrice = () => {
      // Calculate new price: base + selected options
      let newPrice = basePrice
      const $checkedBoxes = $bundleData.find('input.bundled_product_checkbox:checked')

      $checkedBoxes.each(function() {
        const itemId = $(this).attr('name').replace('bundle_selected_optional_', '')
        if (bundleCustomData[itemId] && bundleCustomData[itemId].custom_price) {
          newPrice += parseFloat(bundleCustomData[itemId].custom_price)
        }
      })

      // Update unit price data attribute
      $priceDisplay.attr('data-unit-price', newPrice)

      // Update price display (multiplied by quantity)
      if ($.mlmi && $.mlmi.favorites && $.mlmi.favorites.updateItemPrice) {
        $.mlmi.favorites.updateItemPrice($card)
      }

      // Update wishlist summary
      if ($.mlmi && $.mlmi.favorites && $.mlmi.favorites.updateWishlistSummary) {
        $.mlmi.favorites.updateWishlistSummary()
      }
    }

    const bundleApi = createBundleDropdowns($bundleData, $dropdownContainer, {
      mode: 'append',
      htmlTemplate: 'simple',
      onCheckboxChange: updateBundlePrice
    })

    // Calculate initial price based on default-selected options
    updateBundlePrice()
  },

  page() {
    if ($('.wishlist-list__content').length) {
      // Load list switcher for logged-in users
      const isLoggedIn = $('html').hasClass('--logged-in')
      const isViewingSharedList = $('.wishlist-grid').attr('data-list-id') ? true : false

      // For anonymous users OR viewing someone else's shared list, load immediately
      if (!isLoggedIn || (isLoggedIn && isViewingSharedList && !$('.wishlist-list__switch-list').length)) {
        $('.wishlist-grid').FavoritesPage()
      }

      if (isLoggedIn && $('.wishlist-list__switch-list').length) {
        // Get the menu structure from template
        const template = document.getElementById('tpl-favorite-button')
        const menuHtml = $(template.content).find('.favorite-button__menu').clone()
        menuHtml.find('.favorite-menu__title').html(gourmetsauvage_params.WISHLIST_MY_LISTS)
        // Insert into switch list container
        $('.wishlist-list__switch-list__list').html(menuHtml)

        // Load user lists and populate
        $.ajax({
          url: '/favorites/',
          method: 'POST',
          data: {
            'action': 'get_user_lists',
            'language': gourmetsauvage_params.LANGUAGE,
          },
          success: (response) => {
            try {
              const data = typeof response === 'string' ? JSON.parse(response) : response
              if (data.success && data.lists) {
                const menuContent = $('.wishlist-list__switch-list .favorite-menu__content')
                const menuList = menuContent.find('.favorite-menu__list')
                menuList.empty()

                // Store list metadata
                data.lists.forEach((list) => {
                  $.mlmi.favorites.list_metadata[list.uid] = {
                    title: list.title,
                    slug: list.slug,
                    public: list.public,
                    description: list.description,
                    item_count: list.item_count
                  }
                })

                // Add each list as a button
                data.lists.forEach((list) => {
                  const listButton = $('<button class="wishlist-list__switch-list__item" data-list-uid="' + list.uid + '">' + list.title + '</button>')

                  // Add click handler to switch lists
                  listButton.on('click', function() {
                    const listUid = $(this).attr('data-list-uid')
                    const listTitle = $(this).text()

                    // Update toggle button text
                    $('.wishlist-list__switch-list__toggle span').text(listTitle)

                    // Update sidebar title
                    $('.wishlist-sidebar__title').text(listTitle)

                    // Empty the grid first
                    $('.wishlist-grid').empty()

                    // Update the wishlist-grid data-list-id
                    $('.wishlist-grid').attr('data-list-id', listUid)

                    // Update UI based on list status (public/private)
                    $.mlmi.favorites.updateListUI(listUid)

                    // Update browser URL
                    $.mlmi.favorites.updateBrowserURL(listUid)

                    // Reload the page with the new list
                    $('.wishlist-grid').FavoritesPage()
                  })

                  menuList.append(listButton)
                })

                // Set initial title based on current list or load the first list
                let currentListUid = $('.wishlist-grid').attr('data-list-id')

                // Check if there's a hash in the URL to load a specific list
                const urlHash = window.location.hash.substring(1) // Remove the #
                let listToLoad = null

                if (urlHash && data.lists.length > 0) {
                  // Parse hash: can be "UID" or "UID/slug"
                  const hashParts = urlHash.split('/')
                  const uidFromHash = hashParts[0]

                  // Find list by UID from hash
                  if (uidFromHash) {
                    listToLoad = data.lists.find(list => list.uid === uidFromHash)
                  }
                }

                // If no list is selected and lists exist, select the one from hash or the first one
                if (!currentListUid && data.lists.length > 0) {
                  const firstList = listToLoad || data.lists[0]
                  currentListUid = firstList.uid

                  // Set the data-list-id on the grid
                  $('.wishlist-grid').attr('data-list-id', currentListUid)

                  // Update titles
                  $('.wishlist-sidebar__title').text(firstList.title)
                  $('.wishlist-list__switch-list__toggle span').text(firstList.title)

                  // Empty the grid first
                  $('.wishlist-grid').empty()

                  // Update UI based on list status
                  $.mlmi.favorites.updateListUI(currentListUid)

                  // Update browser URL hash
                  $.mlmi.favorites.updateBrowserURL(currentListUid)

                  // Reload the page with the selected list
                  $('.wishlist-grid').FavoritesPage()
                } else if (currentListUid) {
                  // List already selected, just update titles
                  const currentList = data.lists.find(list => list.uid === currentListUid)
                  if (currentList) {
                    $('.wishlist-sidebar__title').text(currentList.title)
                    $('.wishlist-list__switch-list__toggle span').text(currentList.title)
                  }
                  // Update UI based on list status
                  $.mlmi.favorites.updateListUI(currentListUid)
                }

                // Add event handlers for creating new list
                const addBtn = $('.wishlist-list__switch-list .favorite-menu__add-btn')
                const input = $('.wishlist-list__switch-list .favorite-menu__input')

                // Handle add button click
                addBtn.on('click', function(e) {
                  e.preventDefault()
                  const listName = input.val().trim()

                  $.mlmi.favorites.createNewList(listName, function(list) {
                    // Clear the input on success
                    input.val('')
                  })
                })

                // Handle Enter key in input
                input.on('keypress', function(e) {
                  if (e.key === 'Enter' || e.keyCode === 13) {
                    addBtn.trigger('click')
                  }
                })

                // Add toggle functionality
                const toggle = $('.wishlist-list__switch-list__toggle')
                const list = $('.wishlist-list__switch-list__list')

                // Set initial state (hidden by default via CSS)
                toggle.attr('aria-expanded', 'false')
                list.attr('aria-hidden', 'true')

                // Toggle function
                toggle.on('click', function(e) {
                  e.preventDefault()
                  e.stopPropagation()

                  const isOpen = toggle.attr('aria-expanded') === 'true'

                  if (isOpen) {
                    // Close
                    toggle.attr('aria-expanded', 'false')
                    list.attr('aria-hidden', 'true')
                  } else {
                    // Open
                    toggle.attr('aria-expanded', 'true')
                    list.attr('aria-hidden', 'false')

                    // Initialize scrollbar after CSS transition
                    setTimeout(() => {
                      $.mlmi.favorites.initScrollbar(menuContent)
                    }, 200)
                  }
                })

                // Close when clicking outside
                $(document).on('click', function(e) {
                  if (toggle.attr('aria-expanded') === 'true' && !$(e.target).closest('.wishlist-list__switch-list').length) {
                    toggle.attr('aria-expanded', 'false')
                    list.attr('aria-hidden', 'true')
                  }
                })

                // Close when selecting an item
                $(document).on('click', '.wishlist-list__switch-list__item, .wishlist-list__switch-list .favorite-menu__close', function() {
                  toggle.attr('aria-expanded', 'false')
                  list.attr('aria-hidden', 'true')
                })
              }
            } catch(e) {
              console.error('Error loading lists for switcher:', e)
            }
          },
          error: (error) => {
            console.error('Error loading lists for switcher:', error)
          }
        })
      }

      // Rename list functionality
      $(document).on('click', '.js-wishlist-rename-list', function(e) {
        e.preventDefault()

        // Get current list info
        const currentListUid = $('.wishlist-grid').attr('data-list-id')
        const currentListTitle = $('.wishlist-sidebar__title').text()

        // Translation strings
        const translations = {
          title: gourmetsauvage_params.RENAME_LIST_TITLE,
          placeholder: gourmetsauvage_params.RENAME_LIST_PLACEHOLDER,
          save: gourmetsauvage_params.SAVE_BTN
        }

        // Create input element with jQuery to properly handle special characters
        const inputElement = $('<input type="text" class="wishlist-popup__input" />')
          .val(currentListTitle)
          .attr('placeholder', translations.placeholder)

        // Show modal
        $.mlmi.favorites.showModal({
          title: translations.title,
          content: inputElement,
          ctaText: translations.save,
          secondaryCtaText: gourmetsauvage_params.WISHLIST_CANCEL || 'Annuler',
          onCta: (closeModal) => {
            const newTitle = $('.wishlist-popup__input').val().trim()

            if (newTitle.length > 0 && newTitle !== currentListTitle) {
              // Call rename API
              $.ajax({
                url: '/favorites/',
                method: 'POST',
                data: {
                  'action': 'rename_list',
                  'list_uid': currentListUid,
                  'new_title': newTitle,
                  'language': gourmetsauvage_params.LANGUAGE,
                },
                success: (response) => {
                  try {
                    const data = typeof response === 'string' ? JSON.parse(response) : response

                    if (data.success) {
                      // Update metadata with new title
                      if ($.mlmi.favorites.list_metadata[currentListUid]) {
                        $.mlmi.favorites.list_metadata[currentListUid].title = newTitle
                        // Update slug if returned from API (for public lists)
                        if (data.slug) {
                          $.mlmi.favorites.list_metadata[currentListUid].slug = data.slug
                        }
                      }

                      // Update UI with new title
                      $('.wishlist-sidebar__title').text(newTitle)
                      $('.wishlist-list__switch-list__toggle span').text(newTitle)

                      // Update the list item in the switcher
                      $('.wishlist-list__switch-list__item[data-list-uid="' + currentListUid + '"]').text(newTitle)

                      // Update browser URL if list is public (slug will have changed)
                      const metadata = $.mlmi.favorites.list_metadata[currentListUid]
                      if (metadata && (metadata.public == 1 || metadata.public === true)) {
                        $.mlmi.favorites.updateBrowserURL(currentListUid)
                      }

                      closeModal()
                    } else if (data.error) {
                      console.error('Error renaming list:', data.error)
                    }
                  } catch(e) {
                    console.error('Error parsing response:', e)
                  }
                },
                error: (error) => {
                  console.error('Error renaming list:', error)
                }
              })
            } else {
              closeModal()
            }
          },
          onSecondaryCta: (closeModal) => {
            closeModal()
          },
          onContentReady: (contentContainer) => {
            // Focus the input and select the text
            const input = contentContainer.find('.wishlist-popup__input')
            input.focus().select()

            // Allow Enter key to submit
            input.on('keypress', function(e) {
              if (e.key === 'Enter' || e.keyCode === 13) {
                $('.wishlist-popup__cta').trigger('click')
              }
            })
          }
        })
      })

      // Print functionality
      $(document).on('click', '.js-wishlist-print', function(e) {
        e.preventDefault()
        window.print()
      })

      // PDF download functionality
      $(document).on('click', '.js-wishlist-pdf', function(e) {
        e.preventDefault()

        // Get current list UID
        const currentListUid = $('.wishlist-grid').attr('data-list-id')

        if (!currentListUid) {
          console.error('No list UID found')
          return
        }

        // Open PDF in new window
        const pdfUrl = '/wishlist-pdf?list_uid=' + encodeURIComponent(currentListUid)
        window.open(pdfUrl, '_blank')
      })

      // Delete list functionality
      $(document).on('click', '.js-wishlist-delete-list', function(e) {
        e.preventDefault()

        // Count number of lists
        const numberOfLists = $('.wishlist-list__switch-list__item').length

        // Prevent deletion if only one list remains
        if (numberOfLists <= 1) {
          $.mlmi.favorites.showModal({
            title: gourmetsauvage_params.WISHLIST_CANNOT_DELETE_TITLE,
            content: '<p>' + gourmetsauvage_params.WISHLIST_CANNOT_DELETE_MESSAGE + '</p>',
            ctaText: gourmetsauvage_params.WISHLIST_OK,
            onCta: (closeModal) => {
              closeModal()
            }
          })
          return
        }

        // Get current list info
        const currentListUid = $('.wishlist-grid').attr('data-list-id')
        const currentListTitle = $('.wishlist-sidebar__title').text()

        // Translation strings
        const deleteMessage = gourmetsauvage_params.LANGUAGE === 'fr' ?
          'Êtes-vous sûr de vouloir supprimer la liste <strong>« ' + currentListTitle + ' »</strong> ? Cette action est irréversible.' :
          'Are you sure you want to delete the list <strong>"' + currentListTitle + '"</strong>? This action cannot be undone.'

        const translations = {
          title: gourmetsauvage_params.DELETE_LIST_TITLE,
          message: deleteMessage,
          delete: gourmetsauvage_params.DELETE_BTN,
          cancel: gourmetsauvage_params.WISHLIST_KEEP_LIST
        }

        // Show modal
        $.mlmi.favorites.showModal({
          title: translations.title,
          content: '<p>' + translations.message + '</p>',
          ctaText: translations.delete,
          secondaryCtaText: translations.cancel,
          //modalClass: 'wishlist-popup--danger',
          onCta: (closeModal) => {
            // Delete the list
            $.ajax({
              url: '/favorites/',
              method: 'POST',
              data: {
                'action': 'delete_list',
                'list_uid': currentListUid,
                'language': gourmetsauvage_params.LANGUAGE,
              },
              success: (response) => {
                try {
                  const data = typeof response === 'string' ? JSON.parse(response) : response

                  if (data.success) {
                    // Remove from favorite_lists
                    delete $.mlmi.favorites.favorite_lists[currentListUid]

                    // Close modal
                    closeModal()

                    // Redirect to wishlist page (will show first available list or empty state)
                    window.location.reload()
                  } else if (data.error) {
                    console.error('Error deleting list:', data.error)
                  }
                } catch(e) {
                  console.error('Error parsing response:', e)
                }
              },
              error: (error) => {
                console.error('Error deleting list:', error)
              }
            })
          },
          onSecondaryCta: (closeModal) => {
            // Just close the modal
            closeModal()
          }
        })
      })

      // Make list private functionality
      $(document).on('click', '.js-wishlist-make-private', function(e) {
        e.preventDefault()

        const currentListUid = $('.wishlist-grid').attr('data-list-id')
        const currentListTitle = $('.wishlist-sidebar__title').text()

        const message = (gourmetsauvage_params.WISHLIST_MAKE_PRIVATE_MESSAGE || 'Voulez-vous rendre la liste <strong>« {title} »</strong> privée ? Le lien de partage ne fonctionnera plus.').replace('{title}', currentListTitle)

        $.mlmi.favorites.showModal({
          title: gourmetsauvage_params.WISHLIST_MAKE_PRIVATE_TITLE || 'Rendre la liste privée',
          content: '<p>' + message + '</p>',
          ctaText: gourmetsauvage_params.WISHLIST_MAKE_PRIVATE_BTN || 'Rendre privée',
          secondaryCtaText: gourmetsauvage_params.WISHLIST_CANCEL || 'Annuler',
          onCta: (closeModal) => {
            $.ajax({
              url: '/favorites/',
              method: 'POST',
              data: {
                'action': 'update_list_visibility',
                'list_uid': currentListUid,
                'public': false,
                'language': gourmetsauvage_params.LANGUAGE,
              },
              success: (response) => {
                try {
                  const data = typeof response === 'string' ? JSON.parse(response) : response

                  if (data.success) {
                    // Update metadata
                    if ($.mlmi.favorites.list_metadata[currentListUid]) {
                      $.mlmi.favorites.list_metadata[currentListUid].public = 0
                      $.mlmi.favorites.list_metadata[currentListUid].slug = null
                    }

                    // Update UI
                    $.mlmi.favorites.updateListUI(currentListUid)

                    // Update browser URL (back to base URL)
                    $.mlmi.favorites.updateBrowserURL(currentListUid)

                    // No need to update share button here - updateListUI handles it

                    closeModal()
                  } else if (data.error) {
                    console.error('Error making list private:', data.error)
                  }
                } catch(e) {
                  console.error('Error parsing response:', e)
                }
              },
              error: (error) => {
                console.error('Error making list private:', error)
              }
            })
          },
          onSecondaryCta: (closeModal) => {
            closeModal()
          }
        })
      })

      // Wishlist share functionality - initialize share buttons
      $('.wishlist-share').each(function() {
        $.mlmi.favorites.initializeShareButton($(this))
      })

      // Global event handler for private list share button (event delegation)
      $(document).on('click', '.wishlist-share[data-is-public="0"] .share-button', function(e) {
        e.preventDefault()
        e.stopPropagation()

        const currentListUid = $('.wishlist-grid').attr('data-list-id')
        const currentListTitle = $('.wishlist-sidebar__title').text()

        // Show "Make public" popup
        const inputElement = $('<input type="text" class="wishlist-popup__input" />')
          .val(currentListTitle)
          .attr('placeholder', gourmetsauvage_params.WISHLIST_LIST_NAME_PLACEHOLDER || 'Nom de la liste')

        const contentHtml = $('<div></div>')
          .append('<p>' + (gourmetsauvage_params.WISHLIST_MAKE_PUBLIC_MESSAGE || 'Avant de partager votre liste, vous devez choisir un nom public. Le nom et le contenu de la liste seront visibles par toute personne disposant du lien.') + '</p>')
          .append(inputElement)

        $.mlmi.favorites.showModal({
          title: gourmetsauvage_params.WISHLIST_MAKE_PUBLIC_TITLE || 'Rendre la liste publique',
          content: contentHtml,
          ctaText: gourmetsauvage_params.WISHLIST_CREATE_PUBLIC_LINK || 'Créer un lien public',
          ctaIcon: 'icon-link',
          secondaryCtaText: gourmetsauvage_params.WISHLIST_CANCEL || 'Annuler',
          onCta: (closeModal) => {
            const newTitle = $('.wishlist-popup__input').val().trim()

            if (newTitle.length > 0) {
              // Make list public
              $.ajax({
                url: '/favorites/',
                method: 'POST',
                data: {
                  'action': 'update_list_visibility',
                  'list_uid': currentListUid,
                  'public': true,
                  'language': gourmetsauvage_params.LANGUAGE,
                },
                success: (response) => {
                  try {
                    const data = typeof response === 'string' ? JSON.parse(response) : response

                    if (data.success) {
                      // If title changed, rename the list
                      if (newTitle !== currentListTitle) {
                        $.ajax({
                          url: '/favorites/',
                          method: 'POST',
                          data: {
                            'action': 'rename_list',
                            'list_uid': currentListUid,
                            'new_title': newTitle,
                            'language': gourmetsauvage_params.LANGUAGE,
                          },
                          success: (renameResponse) => {
                            try {
                              const renameData = typeof renameResponse === 'string' ? JSON.parse(renameResponse) : renameResponse

                              if (renameData.success) {
                                // Update metadata
                                if ($.mlmi.favorites.list_metadata[currentListUid]) {
                                  $.mlmi.favorites.list_metadata[currentListUid].title = newTitle
                                  $.mlmi.favorites.list_metadata[currentListUid].public = 1
                                  $.mlmi.favorites.list_metadata[currentListUid].slug = data.slug
                                }

                                // Update UI
                                $('.wishlist-sidebar__title').text(newTitle)
                                $('.wishlist-list__switch-list__toggle span').text(newTitle)
                                $('.wishlist-list__switch-list__item[data-list-uid="' + currentListUid + '"]').text(newTitle)
                                $.mlmi.favorites.updateListUI(currentListUid)

                                // Update browser URL
                                $.mlmi.favorites.updateBrowserURL(currentListUid)

                                closeModal()
                              }
                            } catch(e) {
                              console.error('Error parsing rename response:', e)
                            }
                          }
                        })
                      } else {
                        // Just update metadata
                        if ($.mlmi.favorites.list_metadata[currentListUid]) {
                          $.mlmi.favorites.list_metadata[currentListUid].public = 1
                          $.mlmi.favorites.list_metadata[currentListUid].slug = data.slug
                        }

                        $.mlmi.favorites.updateListUI(currentListUid)

                        // Update browser URL
                        $.mlmi.favorites.updateBrowserURL(currentListUid)

                        closeModal()
                      }
                    } else if (data.error) {
                      console.error('Error making list public:', data.error)
                    }
                  } catch(e) {
                    console.error('Error parsing response:', e)
                  }
                },
                error: (error) => {
                  console.error('Error making list public:', error)
                }
              })
            }
          },
          onSecondaryCta: (closeModal) => {
            closeModal()
          },
          onContentReady: (contentContainer) => {
            const input = contentContainer.find('.wishlist-popup__input')
            input.focus().select()

            input.on('keypress', function(e) {
              if (e.key === 'Enter' || e.keyCode === 13) {
                $('.wishlist-popup__cta').trigger('click')
              }
            })
          }
        })
      })

      // Save notes functionality
      $(document).on('click', '.js-wishlist-save-notes', function(e) {
        e.preventDefault()

        const $btn = $(this)
        const $textarea = $('.wishlist-sidebar__notes__textarea')
        const currentListUid = $('.wishlist-grid').attr('data-list-id')
        const description = $textarea.val()

        if (!currentListUid) {
          return
        }

        // Show saving state
        const originalHtml = $btn.html()
        $btn.addClass('wishlist-sidebar__notes__save--saving')
        $btn.html('<span>' + (gourmetsauvage_params.WISHLIST_SAVING || 'Sauvegarde...') + '</span>')

        $.ajax({
          url: '/favorites/',
          method: 'POST',
          data: {
            'action': 'update_list_description',
            'list_uid': currentListUid,
            'description': description,
            'language': gourmetsauvage_params.LANGUAGE,
          },
          success: (response) => {
            try {
              const data = typeof response === 'string' ? JSON.parse(response) : response

              if (data.success) {
                // Update metadata
                if ($.mlmi.favorites.list_metadata[currentListUid]) {
                  $.mlmi.favorites.list_metadata[currentListUid].description = description
                }

                // Show success state
                $btn.html('<span>' + (gourmetsauvage_params.WISHLIST_SAVED || 'Sauvegardé!') + '</span>')

                setTimeout(() => {
                  $btn.html(originalHtml)
                  $btn.removeClass('wishlist-sidebar__notes__save--saving')
                }, 2000)
              } else if (data.error) {
                console.error('Error saving notes:', data.error)
                $btn.html(originalHtml)
                $btn.removeClass('wishlist-sidebar__notes__save--saving')
              }
            } catch(e) {
              console.error('Error parsing response:', e)
              $btn.html(originalHtml)
              $btn.removeClass('wishlist-sidebar__notes__save--saving')
            }
          },
          error: (error) => {
            console.error('Error saving notes:', error)
            $btn.html(originalHtml)
            $btn.removeClass('wishlist-sidebar__notes__save--saving')
          }
        })
      })

      // Add all products to another list functionality
      $(document).on('click', '.js-wishlist-add-to-other-list', function(e) {
        e.preventDefault()

        const $menu = $('.wishlist-add-to-list-menu')
        const $content = $menu.find('.favorite-menu__content')
        const $list = $content.find('.favorite-menu__list')
        const currentListUid = $('.wishlist-grid').attr('data-list-id')

        // Load all lists
        $.ajax({
          url: '/favorites/',
          method: 'POST',
          data: {
            'action': 'get_user_lists',
            'language': gourmetsauvage_params.LANGUAGE,
          },
          success: (response) => {
            try {
              const data = typeof response === 'string' ? JSON.parse(response) : response

              if (data.success && data.lists) {
                // Clear list
                $list.empty()

                // Filter out current list
                const otherLists = data.lists.filter(list => list.uid !== currentListUid)

                if (otherLists.length === 0) {
                  $list.html('<div style="padding: 20px; text-align: center; color: #999; font-size: 12px;">' +
                    gourmetsauvage_params.WISHLIST_NO_OTHER_LISTS +
                    '</div>')
                } else {
                  // Add list items
                  otherLists.forEach(list => {
                    const $item = $('<button class="favorite-menu__item js-add-to-target-list" data-list-uid="' + list.uid + '">' +
                      '<span class="favorite-menu__name">' + list.title + '</span>' +
                      '</button>')
                    $list.append($item)
                  })
                }

                // Show menu
                $menu.show()

                // Initialize scrollbar after menu is visible
                setTimeout(() => {
                  $.mlmi.favorites.initScrollbar($content)
                }, 50)
              } else if (data.error) {
                console.error('Error loading lists:', data.error)
              }
            } catch(e) {
              console.error('Error parsing response:', e)
            }
          },
          error: (error) => {
            console.error('Error loading lists:', error)
          }
        })
      })

      // Close add to list menu
      $(document).on('click', '.js-wishlist-add-to-list-close', function(e) {
        e.preventDefault()
        $('.wishlist-add-to-list-menu').hide()
      })

      // Close add to list menu when clicking outside
      $(document).on('click', function(e) {
        const $menu = $('.wishlist-add-to-list-menu')
        if ($menu.is(':visible') && !$(e.target).closest('.wishlist-add-to-list-menu, .js-wishlist-add-to-other-list').length) {
          $menu.hide()
        }
      })

      // Handle Enter key in add to list menu input
      $(document).on('keypress', '.js-wishlist-add-to-list-input', function(e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
          e.preventDefault()
          $('.js-wishlist-add-to-list-create').trigger('click')
        }
      })

      // Add all products to selected list
      $(document).on('click', '.js-add-to-target-list', function(e) {
        e.preventDefault()

        const $btn = $(this)
        const targetListUid = $btn.data('list-uid')
        const targetListTitle = $btn.find('.favorite-menu__name').text().trim()
        const $items = $('.wishlist-grid .mlmi-marker[data-content-uid]')

        if ($items.length === 0) {
          $('.wishlist-add-to-list-menu').hide()
          return
        }

        // Show loading state
        $btn.css('opacity', '0.6').css('pointer-events', 'none')

        // Collect all content UIDs
        const contentUids = []
        $items.each(function() {
          const uid = $(this).data('content-uid')
          if (uid) {
            contentUids.push(uid)
          }
        })

        // Add all products to the target list
        let completed = 0
        let hasError = false

        contentUids.forEach((contentUid, index) => {
          setTimeout(() => {
            $.ajax({
              url: '/favorites/',
              method: 'POST',
              data: {
                'action': 'add',
                'content_uid': contentUid,
                'list_uid': targetListUid,
                'language': gourmetsauvage_params.LANGUAGE,
              },
              success: (response) => {
                completed++
                if (completed === contentUids.length && !hasError) {
                  // All done, close menu and show success
                  $('.wishlist-add-to-list-menu').hide()
                  $btn.css('opacity', '1').css('pointer-events', 'auto')

                  // Build success message with list name
                  const successMessage = gourmetsauvage_params.LANGUAGE === 'fr' ?
                    'Tous les produits ont été ajoutés à la liste <strong>« ' + targetListTitle + ' »</strong>.' :
                    'All products have been added to the list <strong>"' + targetListTitle + '"</strong>.'

                  // Show success message
                  $.mlmi.favorites.showModal({
                    title: gourmetsauvage_params.WISHLIST_SUCCESS_TITLE,
                    content: '<p>' + successMessage + '</p>',
                    ctaText: gourmetsauvage_params.WISHLIST_VARIATION_REQUIRED_OK,
                    onCta: (closeModal) => { closeModal() }
                  })
                }
              },
              error: (error) => {
                hasError = true
                completed++
                console.error('Error adding product:', error)

                if (completed === contentUids.length) {
                  $('.wishlist-add-to-list-menu').hide()
                  $btn.css('opacity', '1').css('pointer-events', 'auto')

                  $.mlmi.favorites.showModal({
                    title: gourmetsauvage_params.WISHLIST_ERROR_TITLE,
                    content: '<p>' + gourmetsauvage_params.WISHLIST_ERROR_ADDING_PRODUCTS + '</p>',
                    ctaText: gourmetsauvage_params.WISHLIST_VARIATION_REQUIRED_OK,
                    onCta: (closeModal) => { closeModal() }
                  })
                }
              }
            })
          }, index * 100) // Stagger requests by 100ms
        })
      })

      // Create new list from add to list menu
      $(document).on('click', '.js-wishlist-add-to-list-create', function(e) {
        e.preventDefault()

        const $input = $('.wishlist-add-to-list-menu .favorite-menu__input')
        const newTitle = $input.val().trim()

        if (newTitle.length === 0) {
          return
        }

        const $btn = $(this)
        $btn.css('opacity', '0.6').css('pointer-events', 'none')

        // Use the shared createNewList function
        $.mlmi.favorites.createNewList(newTitle, (list) => {
          // Clear input
          $input.val('')

          // Reload lists in the add-to-other-list menu
          $('.js-wishlist-add-to-other-list').trigger('click')
          $btn.css('opacity', '1').css('pointer-events', 'auto')
        })
      })

      // Add selected items to cart
      $(document).on('click', '.wishlist-summary__add-to-cart-btn', function(e) {
        e.preventDefault()

        const $btn = $(this)

        // Bail if no items selected
        if ($btn.prop('disabled')) {
          return
        }

        // Only add checked items
        const $checkedItems = $('.wishlist-grid .card-wishlist').filter(function() {
          return $(this).find('.js-wishlist-item-check:checked').length > 0
        })
        const $items = $checkedItems.length > 0 ? $checkedItems : $()

        if (!$items.length) {
          return
        }

        // Get current list title
        const currentListUid = $('.wishlist-grid').attr('data-list-id')
        const metadata = $.mlmi.favorites.list_metadata[currentListUid]
        const listTitle = (metadata && metadata.title) || $('.wishlist-sidebar__title').text() || 'Mes favoris'

        // First pass: check if all variable products have variations selected
        let hasIncompleteVariations = false

        $items.each(function() {
          const $item = $(this)
          const $addButton = $item.find('.add_to_cart_button')
          const productId = $addButton.data('product-id') || $addButton.data('product_id')

          // Only check products with ajax_add_to_cart class
          if (productId && $addButton.hasClass('ajax_add_to_cart')) {
            // Check if it's a variable product
            if ($addButton.hasClass('product_type_variable')) {
              const $variations = $item.find('.card-wishlist__variations')

              if ($variations.length) {
                const $selects = $variations.find('select')
                let allSelected = true

                $selects.each(function() {
                  if (!$(this).val() || $(this).val() === '') {
                    allSelected = false
                  }
                })

                const variationId = $addButton.data('variation-id') || 0

                if (!allSelected || variationId === 0) {
                  hasIncompleteVariations = true
                }
              }
            }
          }
        })

        // If there are incomplete variations, show modal and stop
        if (hasIncompleteVariations) {
          $.mlmi.favorites.showModal({
            title: gourmetsauvage_params.WISHLIST_VARIATION_REQUIRED_TITLE,
            content: '<p>' + gourmetsauvage_params.WISHLIST_VARIATION_REQUIRED_MESSAGE_LIST + '</p>',
            ctaText: gourmetsauvage_params.WISHLIST_VARIATION_REQUIRED_OK,
            onCta: (closeModal) => {
              closeModal()
            }
          })

          return
        }

        // Second pass: collect all products with valid data
        const add_item_data = {
          quantity: [],
          product_id: [],
          variation_id: [],
          list_title: listTitle
        }

        $items.each(function() {
          const $item = $(this)
          const $addButton = $item.find('.add_to_cart_button')
          const productId = $addButton.data('product-id') || $addButton.data('product_id')
          const quantity = $item.find('input.qty').val() || 1
          const variationId = $addButton.data('variation-id') || 0

          // Only add products with ajax_add_to_cart class
          if (productId && $addButton.hasClass('ajax_add_to_cart')) {
            add_item_data.product_id.push(productId)
            add_item_data.quantity.push(quantity)
            add_item_data.variation_id.push(variationId)
          }
        })

        if (add_item_data.product_id.length === 0) {
          return
        }

        // Wrap label in span if not already, then switch to loading state
        let $label = $btn.find('.single_add_to_cart_button__label')
        if (!$label.length) {
          const currentText = $btn.text().trim()
          $btn.html('<span class="single_add_to_cart_button__label"></span>')
          $label = $btn.find('.single_add_to_cart_button__label')
          $label.data('original-text', currentText)
          $label.text(currentText)
        } else if (!$label.data('original-text')) {
          $label.data('original-text', $label.text().trim())
        }
        const originalText = $label.data('original-text')
        $btn.addClass('loading').prop('disabled', true)
        $label.text(gourmetsauvage_params.WISHLIST_ADDING_TO_CART)

        // Add to cart
        $.ajax({
          url: window.wc_cart_fragments_params.wc_ajax_url.replace('%%endpoint%%', 'add_to_cart_multiple'),
          type: 'POST',
          data: add_item_data,
          success: function(response) {
            // Show added state briefly then restore original label
            $btn.removeClass('loading').addClass('added').prop('disabled', false)
            $label.text(gourmetsauvage_params.ADDED_TO_CART)
            setTimeout(function() {
              $btn.removeClass('added')
              $label.text(originalText)
            }, 2000)

            // Update cart
            if (response.success && $.mlmi && $.mlmi.cart && $.mlmi.cart.refreshFragments) {
              $.mlmi.cart.refreshFragments(response)
            }

            // Mark all individual add to cart buttons as added
            $items.each(function() {
              const $item = $(this)
              const $addButton = $item.find('.add_to_cart_button')

              if ($addButton.hasClass('ajax_add_to_cart')) {
                $addButton.removeClass('loading').addClass('added')
                $addButton.html(gourmetsauvage_params.ADDED_TO_CART)
              }
            })

            // Deselect all checkboxes and re-disable button
            $('.js-wishlist-item-check').prop('checked', false)
            $('.wishlist-summary__add-to-cart-btn').prop('disabled', true)
            $('.wishlist-summary__add-to-cart-btn[data-toggle="tooltip"]').tooltip()
            $('.js-wishlist-select-all').text(gourmetsauvage_params.SELECT_ALL)

            // Show success message via cart messages
            if (response.added_message) {
              const $messages = $('.mlmi-cart__messages')
              $messages.find('ul').remove()
              $messages.append($('<ul></ul>').append($('<li></li>').html(response.added_message)))
              $messages.attr('aria-hidden', 'false').attr('aria-expanded', 'true')
              $('.mlmi-cart__messages-expand').attr('aria-expanded', 'true').attr('aria-hidden', 'false')
              setTimeout(function() {
                $messages.attr('aria-hidden', 'true')
                $('.mlmi-cart__messages-expand').attr('aria-expanded', 'false')
              }, 5000)
            }
          },
          error: function(xhr, status, error) {
            console.error('Error adding to cart:', error)
            $btn.removeClass('loading').prop('disabled', false)
            $btn.html(originalHtml)
          }
        })
      })
    }
  },

  history() {
    if ($('.history-products').length) {
      // Check if cached history HTML is still valid
      let cachedTimestamp = localStorage.getItem('history_html_timestamp')
      let cacheMaxAge = 60 * 60 * 1000 // 1 hour in milliseconds
      let now = Date.now()

      // If no timestamp but we have cached HTML, it's old cache - clear it
      if (this.history_html && !cachedTimestamp) {
        this.history_html = ''
        localStorage.setItem('history_html', '')
        localStorage.removeItem('history_html_version')
      }
      // If cache is older than 1 hour, clear it to force refetch
      else if (cachedTimestamp && (now - parseInt(cachedTimestamp)) > cacheMaxAge) {
        this.history_html = ''
        localStorage.setItem('history_html', '')
        localStorage.removeItem('history_html_timestamp')
        localStorage.removeItem('history_html_version')
      }

      let history = $('<div>').html(this.history_html),
      current_uid = $('.single-product-page__product .favorite__toggle').data('content-uid'),
      products = history.find('.product-list__item')
      if (products.length) {
        $('.history-products .grid').addClass('grid--postitem__product')
        let productsCounter = 0
        products.each(function(index, card) {
          if (productsCounter < 15) {
            if (current_uid && $(card).find('.favorite__toggle').data('content-uid') == current_uid) {
              return
            }
            productsCounter++
            let gridItem = $('<div>').addClass('grid__item carousel__slide swiper-slide').append(card)
            $('.history-products .grid').append(gridItem)
          }
        })
        $('.carousel-placeholder').addClass('carousel swiper-container').removeClass('carousel-placeholder')
        Carousel_CoreInit(carouselConfigs, $('.history-products'))

        // Initialize on the loaded history items
        $.mlmi.favorites.buttons($('.history-products'))
        $('.history-products input.qty').each(function() {
          $(this).Quantity()
        })

        // Update CSS variable after history loads
        const searchBar = $('.search-bar')
        if (searchBar.length && typeof searchBar.updateRecentProductsHeight === 'function') {
          searchBar.updateRecentProductsHeight()
        }
      } else {
        $('.history-products').remove()
      }
    }
  },

  hit() {
    var favorites = $.mlmi.favorites,
    content_uid = $('.single-product-page__product .favorite__toggle').data('content-uid')

    // Only process if we have a valid content_uid
    if (!content_uid) {
      return
    }

    var content_index = favorites.history_items.indexOf(content_uid)
    if (content_index !== -1) {
      favorites.history_items.splice(content_index, 1)
    }
    favorites.history_items.unshift(content_uid)
    if (favorites.history_items.length > 35) {
      favorites.history_items = favorites.history_items.slice(0, 35)
    }

    // Filter out any undefined/null/empty values
    favorites.history_items = favorites.history_items.filter(uid => uid && uid !== '')
    localStorage.setItem('history_items', JSON.stringify(favorites.history_items))
    favorites.setCookie('history_items', favorites.history_items.join('|'), 30)

    // Only make AJAX call if we have valid items
    if (favorites.history_items.length > 0) {
      $.ajax({
        url: '/favorites/',
        method: 'POST',
        data: {
          'action': 'recent',
          'list_uid': $.mlmi.favorites.id,
          'history_items': favorites.history_items,
          'language': gourmetsauvage_params.LANGUAGE,
        },
        success: function(response) {
          $.mlmi.favorites.history_html = response
          localStorage.setItem('history_html', $.mlmi.favorites.history_html)

          // Store timestamp for cache expiry (1 hour)
          localStorage.setItem('history_html_timestamp', Date.now())

          // Extract and store fragment version for reference
          let $response = $('<div>').html(response)
          let version = $response.find('.fragment-version').data('version')
          if (version) {
            localStorage.setItem('history_html_version', version)
          }
        },
      })
    }
  },

  init() {
    if ('localStorage' in window) {
      this.id = localStorage.getItem('favorites_id')
      this.history_items = localStorage.getItem('history_items')
      this.history_html = localStorage.getItem('history_html')

      if (!this.id) {
        this.id = this.generateFavoritesUid()
        this.favorite_items = []
        this.history_items = []
        this.history_html = ''
        localStorage.setItem('favorites_id', this.id)
        localStorage.setItem('history_items', JSON.stringify(this.history_items))
        localStorage.setItem('history_html', this.history_html)
      } else {
        this.favorite_items = []
        this.history_items = this.history_items ? JSON.parse(this.history_items) : []
        this.history_html = this.history_html || ''

        if (!this.history_html) {
          localStorage.setItem('history_html', '')
        }
      }

      this.setCookie('favorites_list_uid', this.id, 365)
      this.setCookie('history_items', this.history_items.join('|'), 30)
    }
    $.mlmi.favorites = this

    const isLoggedIn = $('html').hasClass('--logged-in')

    // If user is logged in and favorites are provided in footer, use them
    if (typeof mlmi_favorites !== 'undefined' && Array.isArray(mlmi_favorites)) {
      this.favorite_items = mlmi_favorites

      // If favorite_lists and list_metadata are also provided (optimization), use them
      if (typeof mlmi_favorite_lists !== 'undefined' && typeof mlmi_list_metadata !== 'undefined') {
        this.favorite_lists = mlmi_favorite_lists
        this.list_metadata = mlmi_list_metadata

        this.buttons()
        this.history()
        this.hit()
        this.page()
        this.updateFavoriteCount()
      } else if (isLoggedIn) {
        // Fallback: load lists via AJAX (legacy behavior)
        this.loadAllUserLists(() => {
          this.buttons()
          this.history()
          this.hit()
          this.page()
          this.updateFavoriteCount()
        })
      } else {
        this.buttons()
        this.history()
        this.hit()
        this.page()
        this.updateFavoriteCount()
      }
    } else {
      // For logged-in users, load all lists; for anonymous, load single list
      if (isLoggedIn) {
        this.loadAllUserLists(() => {
          this.buttons()
          this.history()
          this.hit()
          this.page()
          this.updateFavoriteCount()
        })
      } else {
        this.loadFavorites()
        // history(), hit(), page() will be called after loadFavorites completes
      }
    }
  },
}

$.fn.FavoriteButton = function() {
  let self = this

  if (self.data('favorite-button')) {
    return self.data('favorite-button');
  }

  var list_uid = $.mlmi.favorites.id
  if ($(self).attr('data-list-uid') !== undefined) {
    list_uid = $(self).attr('data-list-uid')
  }
  self.pressed = self.attr('aria-pressed') === 'true'

  // Try to find favorite button - first check if there's a stored reference
  let favoriteButton = self.closest('.favorite-button__menu').data('favorite-button-ref')
  if (!favoriteButton || !favoriteButton.length) {
    // Fallback to direct DOM traversal (for menu items that haven't been moved)
    favoriteButton = self.closest('.favorite-button')
  }
  self.uid = favoriteButton.siblings('.mlmi-marker').first().data('content-uid')
  self.add = function() {
    $.mlmi.favorites.add(self.uid, list_uid)
    favorites.updateFavoriteCount()

    $.ajax({
      url: '/favorites/',
      method: 'POST',
      data: {
        'action': 'add',
        'list_uid': list_uid,
        'content_uid': self.uid,
        'language': gourmetsauvage_params.LANGUAGE,
      },
      success: function(response) {
        try {
          const data = typeof response === 'string' ? JSON.parse(response) : response
          if (data && data.list_uid && data.list_uid !== $.mlmi.favorites.id) {
            $.mlmi.favorites.id = data.list_uid
            localStorage.setItem('favorites_id', data.list_uid)
            $.mlmi.favorites.setCookie('favorites_list_uid', data.list_uid, 365)
          }
        } catch(e) {
        }
      },
      error: function(error) {
        $.mlmi.favorites.remove(self.uid, list_uid)
        self.toggle_off()
      },
    })
  }

  self.remove = function() {
    $.mlmi.favorites.remove(self.uid, list_uid)
    favorites.updateFavoriteCount()

    $.ajax({
      url: '/favorites/',
      method: 'POST',
      data: {
        'action': 'remove',
        'list_uid': list_uid,
        'content_uid': self.uid,
      },
      success: function(response) {
        try {
          const data = typeof response === 'string' ? JSON.parse(response) : response
          if (data && data.list_uid && data.list_uid !== $.mlmi.favorites.id) {
            $.mlmi.favorites.id = data.list_uid
            localStorage.setItem('favorites_id', data.list_uid)
            $.mlmi.favorites.setCookie('favorites_list_uid', data.list_uid, 365)
          }
        } catch(e) {
        }
      },
      error: function(error) {
        $.mlmi.favorites.add(self.uid, list_uid)
        self.toggle_on()
      },
    })
  }

  self.toggle_on = function() {
    self.pressed = true
    self.attr('aria-pressed', 'true')

    const isLoggedIn = $('html').hasClass('--logged-in')

    // Try to find favorite button - first check if there's a stored reference
    let favoriteButton = self.closest('.favorite-button__menu').data('favorite-button-ref')
    if (!favoriteButton || !favoriteButton.length) {
      // Fallback to direct DOM traversal (for menu items that haven't been moved)
      favoriteButton = self.closest('.favorite-button')
    }

    if (isLoggedIn && self.hasClass('favorite-menu__item')) {
      // For menu items: check if ANY menu item is pressed
      // Must search in the menu, not in favoriteButton, since menu might be moved to body
      const menu = self.closest('.favorite-button__menu')
      const anyPressed = menu.find('.favorite-menu__item[aria-pressed="true"]').length > 0
      favoriteButton.attr('aria-pressed', anyPressed ? 'true' : 'false')
      favoriteButton.find('.favorite-button__toggle span').text(
        anyPressed ? gourmetsauvage_params.ADDED_TO_FAVORITES : gourmetsauvage_params.ADD_TO_FAVORITES
      )
    } else {
      // For anonymous users or non-menu items
      favoriteButton.attr('aria-pressed', 'true')
      favoriteButton.find('.favorite-button__toggle span').text(gourmetsauvage_params.ADDED_TO_FAVORITES)
    }
  }

  self.toggle_off = function() {
    self.pressed = false
    self.attr('aria-pressed', 'false')

    const isLoggedIn = $('html').hasClass('--logged-in')

    // Try to find favorite button - first check if there's a stored reference
    let favoriteButton = self.closest('.favorite-button__menu').data('favorite-button-ref')
    if (!favoriteButton || !favoriteButton.length) {
      // Fallback to direct DOM traversal (for menu items that haven't been moved)
      favoriteButton = self.closest('.favorite-button')
    }

    if (isLoggedIn && self.hasClass('favorite-menu__item')) {
      // For menu items: check if ANY menu item is pressed
      // Must search in the menu, not in favoriteButton, since menu might be moved to body
      const menu = self.closest('.favorite-button__menu')
      const anyPressed = menu.find('.favorite-menu__item[aria-pressed="true"]').length > 0
      favoriteButton.attr('aria-pressed', anyPressed ? 'true' : 'false')
      favoriteButton.find('.favorite-button__toggle span').text(
        anyPressed ? gourmetsauvage_params.ADDED_TO_FAVORITES : gourmetsauvage_params.ADD_TO_FAVORITES
      )
    } else {
      // For anonymous users or non-menu items
      favoriteButton.attr('aria-pressed', 'false')
      favoriteButton.find('.favorite-button__toggle span').text(gourmetsauvage_params.ADD_TO_FAVORITES)
    }
  }

  self.clicked = function(e) {
    e.preventDefault()
    e.stopPropagation()

    if (self.pressed) {
      self.toggle_off()
      self.remove()
      $('body').find('button.favorite__toggle[data-content-uid="' + self.uid + '"]').not(self).FavoriteButton().toggle_off()
    } else {
      self.toggle_on()
      self.add()
      $('body').find('button.favorite__toggle[data-content-uid="' + self.uid + '"]').not(self).FavoriteButton().toggle_on()
    }
  }

  return function() {
    self.on('click', self.clicked)
    // Check if item is in this specific list (if list_uid exists) or in general
    if ($.mlmi.favorites.has(self.uid, list_uid)) {
      self.toggle_on()
    } else {
      self.toggle_off()
    }
    self.data('favorite-button', self)
    return self
  }()
}

$.fn.FavoriteMenuToggle = function() {
  let self = this

  if (self.data('favorite-menu-toggle')) {
    return self.data('favorite-menu-toggle');
  }

  self.menu = self.siblings('.favorite-button__menu')
  self.isOpen = false
  self.listsLoaded = false
  self.originalParent = self.menu.parent()

  self.positionMenu = function() {
    // Get the .favorite-button container (parent of the toggle button)
    const favoriteButton = self.closest('.favorite-button')[0]
    const buttonRect = favoriteButton.getBoundingClientRect()

    // Position menu to match the favorite-button exactly
    self.menu.css({
      position: 'absolute',
      top: (buttonRect.top + window.scrollY) + 'px',
      left: (buttonRect.left + window.scrollX) + 'px',
      width: buttonRect.width + 'px',
      height: buttonRect.height + 'px',
      transform: 'none'
    })

    // Check if the inner .favorite-menu goes off the right edge and adjust
    const innerMenu = self.menu.find('.favorite-menu')[0]
    if (innerMenu) {
      const innerMenuRect = innerMenu.getBoundingClientRect()
      const innerMenuRight = innerMenuRect.right
      const windowWidth = $(window).width()
      const minDistance = 10

      if (innerMenuRight > windowWidth - minDistance) {
        const offsetNeeded = windowWidth - minDistance - innerMenuRight
        self.menu.css('transform', `translateX(${offsetNeeded}px)`)
      }
    }
  }

  self.handleScroll = function() {
    if (self.isOpen) {
      self.positionMenu()
    }
  }

  self.loadLists = function(callback) {
    if (self.listsLoaded) {
      if (callback) callback()
      return
    }

    const isLoggedIn = $('html').hasClass('--logged-in')
    if (!isLoggedIn) {
      self.listsLoaded = true
      if (callback) callback()
      return
    }

    $.ajax({
      url: '/favorites/',
      method: 'POST',
      data: {
        'action': 'get_user_lists',
        'language': gourmetsauvage_params.LANGUAGE,
      },
      success: function(response) {
        try {
          const data = typeof response === 'string' ? JSON.parse(response) : response

          if (data.success && data.lists) {
            const menuContent = self.menu.find('.favorite-menu__content')
            const menuList = menuContent.find('.favorite-menu__list')
            menuList.empty()

            // Get the content_uid for this product
            // Try to use stored reference first (menu might have been moved to body)
            let favoriteButton = self.menu.data('favorite-button-ref')
            if (!favoriteButton || !favoriteButton.length) {
              // Fallback to direct DOM traversal
              favoriteButton = self.menu.closest('.favorite-button')
            }
            const contentUid = favoriteButton.siblings('.mlmi-marker').first().data('content-uid')

            data.lists.forEach(function(list) {
              const newItem = $('<button class="favorite-menu__item" data-list-uid="' + list.uid + '"><div class="favorite-menu__name"><span>' + list.title + '</span></div></button>')

              // Set initial aria-pressed state based on whether item is in this list
              if (contentUid && $.mlmi.favorites.has(contentUid, list.uid)) {
                newItem.attr('aria-pressed', 'true')
              } else {
                newItem.attr('aria-pressed', 'false')
              }

              menuList.append(newItem)
              newItem.FavoriteButton()
            })

            // Update toggle button based on menu items
            // Must search in the menu, not in favoriteButton, since menu might be moved to body
            const anyPressed = self.menu.find('.favorite-menu__item[aria-pressed="true"]').length > 0
            if (anyPressed) {
              favoriteButton.attr('aria-pressed', 'true')
              self.find('span').text(gourmetsauvage_params.ADDED_TO_FAVORITES)
            } else {
              favoriteButton.attr('aria-pressed', 'false')
              self.find('span').text(gourmetsauvage_params.ADD_TO_FAVORITES)
            }

            setTimeout(() => {
              self.menuScrollbar = $.mlmi.favorites.initScrollbar(menuContent, self.menuScrollbar)
            }, 50)

            self.listsLoaded = true
            if (callback) callback()
          } else if (data.error) {
            console.error('Error loading lists:', data.error)
            if (callback) callback()
          }
        } catch(e) {
          console.error('Error parsing response:', e)
          if (callback) callback()
        }
      },
      error: function(error) {
        console.error('Error loading lists:', error)
        if (callback) callback()
      }
    })
  }

  self.open = function() {
    self.isOpen = true
    self.attr('aria-expanded', 'true')

    // Store reference to favorite button before moving
    const favoriteButton = self.menu.closest('.favorite-button')
    self.menu.data('favorite-button-ref', favoriteButton)

    // Check if inside .wishlist-action-buttons and add class if so
    const isInWishlist = favoriteButton.closest('.wishlist-action-buttons').length > 0
    if (isInWishlist) {
      self.menu.addClass('--product-page-toggle')
    }

    // Load lists first, then show menu
    self.loadLists(function() {
      // Make menu visible but hidden for measurement
      self.menu.css({
        display: 'block',
        visibility: 'hidden',
        opacity: 0
      })

      // Move menu to .app root
      self.menu.appendTo('.app')

      // Position menu (now it can be measured properly)
      self.positionMenu()

      // Make visible and fade in
      self.menu.css('visibility', 'visible')
      self.menu.animate({ opacity: 1 }, 200)

      // Add scroll listener
      $(window).on('scroll', self.handleScroll)
    })
  }

  self.close = function() {
    self.isOpen = false
    self.attr('aria-expanded', 'false')

    // Remove scroll listener
    $(window).off('scroll', self.handleScroll)

    // Fade out with opacity
    self.menu.animate({ opacity: 0 }, 200, function() {
      // Hide the menu
      self.menu.hide()

      // Move menu back to original parent
      self.menu.appendTo(self.originalParent)

      // Clean up stored reference
      self.menu.removeData('favorite-button-ref')

      // Remove wishlist class if present
      self.menu.removeClass('favorite-button__menu--wishlist')

      // Reset styles
      self.menu.css({
        position: '',
        top: '',
        left: '',
        width: '',
        height: '',
        transform: '',
        opacity: '',
        visibility: ''
      })
    })
  }

  self.toggle = function(e) {
    e.preventDefault()
    e.stopPropagation()

    if (self.isOpen) {
      self.close()
    } else {
      // Close all other open menus first
      $('.favorite-button__toggle').each(function() {
        const instance = $(this).data('favorite-menu-toggle')
        if (instance && instance.isOpen && instance !== self) {
          instance.close()
        }
      })
      self.open()
    }
  }

  self.handleClickOutside = function(e) {
    if (self.isOpen && !$(e.target).closest('.favorite-button').length) {
      self.close()
    }
  }

  self.handleClose = function(e) {
    e.preventDefault()
    self.close()
  }

  self.handleAddNewList = function(e) {
    e.preventDefault()

    const input = self.menu.find('.favorite-menu__input')
    const listName = input.val().trim()

    // Get the content_uid from the mlmi-marker
    const contentUid = self.closest('.favorite-button').siblings('.mlmi-marker').first().data('content-uid')

    $.mlmi.favorites.createNewList(listName, function(list) {
      // Clear the input on success
      input.val('')

      // Add the product to the newly created list
      if (contentUid && list.uid) {
        $.ajax({
          url: '/favorites/',
          method: 'POST',
          data: {
            'action': 'add',
            'list_uid': list.uid,
            'content_uid': contentUid,
            'language': gourmetsauvage_params.LANGUAGE,
          },
          success: function(response) {
            // Add to local favorites
            $.mlmi.favorites.add(contentUid, list.uid)
            $.mlmi.favorites.updateFavoriteCount()

            // Toggle on the newly created list item
            const newMenuItem = self.menu.find('.favorite-menu__item[data-list-uid="' + list.uid + '"]')
            if (newMenuItem.length) {
              const buttonInstance = newMenuItem.data('favorite-button')
              if (buttonInstance && buttonInstance.toggle_on) {
                buttonInstance.toggle_on()
              }
            }

            // Don't close the menu - keep it open so user can see the result
          },
          error: function(error) {
            console.error('Error adding product to new list:', error)
          }
        })
      }
    })
  }

  self.handleInputKeypress = function(e) {
    if (e.key === 'Enter' || e.keyCode === 13) {
      self.handleAddNewList(e)
    }
  }

  return function() {
    // Set initial state
    self.attr('aria-expanded', 'false')
    self.menu.hide()

    // Bind events
    self.on('click', self.toggle)
    $(document).on('click', self.handleClickOutside)
    self.menu.find('.favorite-menu__close').on('click', self.handleClose)
    self.menu.find('.favorite-menu__add-btn').on('click', self.handleAddNewList)
    self.menu.find('.favorite-menu__input').on('keypress', self.handleInputKeypress)

    // Handle window resize for open menus only
    $(window).on('resize', function() {
      if (self.isOpen) {
        self.positionMenu()
      }
    })

    self.data('favorite-menu-toggle', self)
    return self
  }()
}

$.fn.FavoritesPage = function() {
  let self = this

  self.is_shared_list = self.data('list-id') ? true : false

  self.copy_link = function(e) {
    e.preventDefault()
    let target = $(this)
    self.original_text = target.find('span').html()
    let textarea = $('<textarea>')
    textarea.val(target.attr('href'))
    target.append(textarea)
    textarea.focus().select()
    document.execCommand("Copy")
    textarea.remove()
    target.find('span').html(gourmetsauvage_params.COPIED_LINK);
    setTimeout(function() {
      target.find('span').html(self.original_text);
    }, 3200)
    return false;
  }

  return function() {
    /* Favorites list */
    if (!self.is_shared_list) {
      self.attr('data-list-id', $.mlmi.favorites.id)
      $('.share-favorites').attr('href', $('.share-favorites').attr('href') + $.mlmi.favorites.id + '/')
      $('.share-favorites').removeClass('d-none').on('click', self.copy_link)
    }

    /* Determine which items to load */
    let itemsToLoad = $.mlmi.favorites.favorite_items
    const isLoggedIn = $('html').hasClass('--logged-in')
    const listId = self.attr('data-list-id')

    if (isLoggedIn && listId && !self.is_shared_list) {
      // For logged-in users with a specific list selected, use items from that list
      itemsToLoad = $.mlmi.favorites.favorite_lists[listId] || []
    }

    /* Show loading state */
    $('.wishlist-spinner').addClass('wishlist-spinner--visible')
    $('.wishlist-list__content').addClass('wishlist-list__content--loading')
    $('.wishlist-list__footer').hide()
    $('.wishlist-list__header').hide()
    $('.wishlist-grid').hide()
    $('.wishlist-empty').hide()

    /* Load items */
    $.ajax({
      url: '/favorites/',
      method: 'POST',
      data: {
        'action': 'get_page',
        'language': gourmetsauvage_params.LANGUAGE,
        'items': self.is_shared_list ? 0 : itemsToLoad,
        'list_uid': listId,
      },
      success: function(response) {
        response = $('<div>').append(response)
        let favoritesCount = 0

        /* Products */
        response.find('.card-wishlist').each(function() {
          let productCard = $(this).removeClass('fade-in'),
          gridItem = $('<div>').addClass('grid__item').append(productCard)
          $('.wishlist-grid').append(gridItem)
          favoritesCount++
        })

        /* Remove previous select all button and reset add-to-cart state */
        $('.js-wishlist-select-all').remove()
        $('.wishlist-summary__add-to-cart-btn').prop('disabled', true)
        $('.wishlist-summary__add-to-cart-btn[data-toggle="tooltip"]').tooltip()

        /* Add selection checkboxes to each card */
        $('.wishlist-grid .card-wishlist').each(function() {
          const $card = $(this)
          const contentUid = $card.find('.mlmi-marker').data('content-uid') || ''
          const canAddToCart = $card.find('.add_to_cart_button').length > 0
          const disabledAttr = canAddToCart ? '' : ' disabled'
          const disabledClass = canAddToCart ? '' : ' card-wishlist__checkbox--disabled'
          const $checkbox = $('<label class="s-checkbox card-wishlist__checkbox' + disabledClass + '"><input type="checkbox" class="js-wishlist-item-check" data-content-uid="' + contentUid + '"' + disabledAttr + ' /><span></span></label>')
          $card.prepend($checkbox)
        })

        /* Add select all / deselect all toggle */
        if (favoritesCount > 0) {
          const $selectAll = $('<button class="wishlist-select-all js-wishlist-select-all">' + gourmetsauvage_params.SELECT_ALL + '</button>')
          $('.wishlist-list__content').prepend($selectAll)
        }

        /* Remove delete buttons if viewing a public shared list (not managing your own) */
        if ($('.wishlist-list__container').hasClass('wishlist-list__container--shared-view')) {
          $('.card-wishlist__remove').remove()
        }

        $('.wishlist-grid .qty').each(function() {
          $(this).Quantity()
        })

        /* Initialize item prices based on quantity */
        $('.card-wishlist').each(function() {
          $.mlmi.favorites.updateItemPrice($(this))
        })

        /* Hide loading state */
        $('.wishlist-spinner').removeClass('wishlist-spinner--visible')
        $('.wishlist-list__content').removeClass('wishlist-list__content--loading')

        /* Show interface */
        if (favoritesCount > 0) {
          // Has items - show grid and summary
          $('.wishlist-grid').show()
          $('.wishlist-empty').hide()
          $('.wishlist-list__footer').show()
          $('.wishlist-list__header').show()
          $('.wishlist-summary').addClass('wishlist-summary--visible')
        } else {
          // Empty list - show empty state message
          $('.wishlist-grid').hide()
          $('.wishlist-empty').show()
          $('.wishlist-list__footer').hide()
          $('.wishlist-list__header').hide()
          $('.wishlist-summary').removeClass('wishlist-summary--visible')
        }

        /* Update wishlist summary */
        $.mlmi.favorites.updateWishlistSummary()

        /* Initialize CartButton for add to cart buttons */
        $('.wishlist-grid .ajax_add_to_cart, .favorites-grid .ajax_add_to_cart').each(function() {
          $(this).CartButton()
        })

        /* Initialize variation selectors for variable products */
        $('.wishlist-grid .card-wishlist').each(function() {
          $.mlmi.favorites.handleVariationSelection($(this))
        })

        /* Initialize bundle dropdowns for bundle products */
        $('.wishlist-grid .card-wishlist').each(function() {
          $.mlmi.favorites.initializeBundleDropdowns($(this))
        })

        /* Apply saved configuration (quantities, variations, bundle options) */
        // Look for the config script in the AJAX response (not in DOM)
        const $savedConfig = response.find('#wishlist-saved-config')
        if ($savedConfig.length) {
          try {
            const savedData = JSON.parse($savedConfig.text())

            // Set list UID on wishlist-grid for future saves
            if (savedData.list_uid) {
              $('.wishlist-grid').attr('data-list-id', savedData.list_uid)
            }

            // Apply saved configuration
            if (savedData.items_config) {
              $.mlmi.favorites.applyListConfig(savedData.items_config)
            }
          } catch (e) {
            console.error('Failed to parse saved wishlist config:', e)
          }
        }

        /* Initialize sticky sidebar with FixedContent (only if left column is taller) */
        setTimeout(function() {
          $('.wishlist-sidebar__fixed').each(function() {
            const $fixed = $(this)
            const existingInstance = $fixed.data('fixedContent')
            if (existingInstance) {
              existingInstance.destroy()
              $fixed.removeData('fixedContent')
            }
            const $wishlistList = $('.wishlist-list')
            $fixed[0].offsetHeight // force reflow after destroy
            if ($wishlistList.outerHeight() > $fixed.outerHeight()) {
              let limitFromTop = 20
              if ($('.top-bar').length) {
                limitFromTop += $('.top-bar').outerHeight(false)
              }
              $fixed.FixedContent({
                limitFromTop: limitFromTop,
                bottomBlocker: $('.wishlist-sidebar__end').first(),
              })
            }
          })
        }, 200)

        /* Initialize tooltips on disabled add-to-cart buttons */
        $('.wishlist-summary__add-to-cart-btn[data-toggle="tooltip"]').tooltip()

        /* Checkbox selection handlers (unbind first to prevent duplicates on list switch) */
        $(document).off('change.wishlistCheck').on('change.wishlistCheck', '.js-wishlist-item-check', function() {
          const checkedCount = $('.js-wishlist-item-check:checked').length
          const totalCount = $('.js-wishlist-item-check:not(:disabled)').length
          const $addBtns = $('.wishlist-summary__add-to-cart-btn')

          if (checkedCount > 0) {
            $addBtns.prop('disabled', false).tooltip('dispose')
          } else {
            $addBtns.prop('disabled', true)
            $addBtns.filter('[data-toggle="tooltip"]').tooltip()
          }

          // Update select all label
          const $selectAll = $('.js-wishlist-select-all')
          if (checkedCount >= totalCount) {
            $selectAll.text(gourmetsauvage_params.DESELECT_ALL)
          } else {
            $selectAll.text(gourmetsauvage_params.SELECT_ALL)
          }
        })

        /* Select all / Deselect all */
        $(document).off('click.wishlistSelectAll').on('click.wishlistSelectAll', '.js-wishlist-select-all', function() {
          const $checks = $('.js-wishlist-item-check:not(:disabled)')
          const allChecked = $checks.length === $checks.filter(':checked').length
          $checks.prop('checked', !allChecked).first().trigger('change')
        })

        /* Validation before add to cart for variable products */
        $(document).on('click', '.wishlist-grid .product_type_variable', function(e) {
          const $button = $(this)
          const $card = $button.closest('.card-wishlist')
          const $variations = $card.find('.card-wishlist__variations')

          if ($variations.length) {
            const $selects = $variations.find('select')
            let allSelected = true

            $selects.each(function() {
              const $select = $(this)
              if (!$select.val() || $select.val() === '') {
                allSelected = false
              }
            })

            if (!allSelected) {
              e.preventDefault()
              e.stopImmediatePropagation()

              $.mlmi.favorites.showModal({
                title: gourmetsauvage_params.WISHLIST_VARIATION_REQUIRED_TITLE,
                content: '<p>' + gourmetsauvage_params.WISHLIST_VARIATION_REQUIRED_MESSAGE + '</p>',
                ctaText: gourmetsauvage_params.WISHLIST_VARIATION_REQUIRED_OK,
                onCta: (closeModal) => {
                  closeModal()
                }
              })

              return false
            }
          }
        })

        /* Quantity change handlers */
        $('.card-wishlist input.qty').on('change input', function() {
          const $item = $(this).closest('.card-wishlist')
          // Update this item's price display
          $.mlmi.favorites.updateItemPrice($item)
          // Update summary totals
          $.mlmi.favorites.updateWishlistSummary()
          // Save configuration
          $.mlmi.favorites.saveListConfig()
        })

        /* Variation change handlers - save config */
        $('.card-wishlist .card-wishlist__variations select').on('change', function() {
          $.mlmi.favorites.saveListConfig()
        })

        /* Bundle dropdown change handlers - save config */
        $('.card-wishlist .card-wishlist__bundle-dropdowns select').on('change', function() {
          $.mlmi.favorites.saveListConfig()
        })

        /* Remove buttons */
        $('.card-wishlist__remove').on('click', function(e) {
          e.preventDefault()
          let card = $(this).closest('.card-wishlist')
          let contentUid = card.find('.mlmi-marker').data('content-uid')

          if (contentUid) {
            // Get product title for confirmation message
            const productTitle = card.find('.card-wishlist__title').text().trim()

            // Translation strings
            const removeMessage = gourmetsauvage_params.LANGUAGE === 'fr' ?
              'Êtes-vous sûr de vouloir retirer <strong>« ' + productTitle + ' »</strong> de cette liste ?' :
              'Are you sure you want to remove <strong>"' + productTitle + '"</strong> from this list?'

            const translations = {
              title: gourmetsauvage_params.WISHLIST_REMOVE_PRODUCT_TITLE,
              message: removeMessage,
              remove: gourmetsauvage_params.WISHLIST_REMOVE_CONFIRM,
              cancel: gourmetsauvage_params.WISHLIST_CANCEL
            }

            // Show confirmation modal
            $.mlmi.favorites.showModal({
              title: translations.title,
              content: '<p>' + translations.message + '</p>',
              ctaText: translations.remove,
              secondaryCtaText: translations.cancel,
              onCta: (closeModal) => {
                // Get the current list_uid from the displayed wishlist grid
                const currentListUid = $('.wishlist-grid').attr('data-list-id')

                // Remove from favorites via AJAX
                $.ajax({
                  url: '/favorites/',
                  method: 'POST',
                  data: {
                    'action': 'remove',
                    'list_uid': currentListUid,
                    'content_uid': contentUid,
                  },
                  success: function(response) {
                    // Parse JSON response if it's a string
                    let data = response
                    if (typeof response === 'string') {
                      try {
                        data = JSON.parse(response)
                      } catch(e) {
                        // Old format, just "1"
                        data = { status: 'ok' }
                      }
                    }

                    $.mlmi.favorites.remove(contentUid, currentListUid)
                    favorites.updateFavoriteCount()

                    // Close modal
                    closeModal()

                    // Remove the card from DOM with animation
                    let gridItem = card.closest('.grid__item')
                    gridItem.css('overflow', 'hidden')
                    gridItem.animate({
                      opacity: 0,
                      height: 0,
                      marginTop: 0,
                      marginBottom: 0,
                      paddingTop: 0,
                      paddingBottom: 0
                    }, 300, function() {
                      gridItem.remove()
                      // Update summary after removal
                      $.mlmi.favorites.updateWishlistSummary()

                      // Check if there are any items left
                      if ($('.card-wishlist').length === 0) {
                        $('.wishlist-grid').hide()
                        $('.wishlist-empty').fadeIn(200)
                        $('.wishlist-list__footer').hide()
                        $('.wishlist-list__header').hide()
                        $('.wishlist-summary').removeClass('wishlist-summary--visible')
                      }
                    })

                    // // Update all other favorite buttons with same uid
                    // $('body').find('button.favorite__toggle[data-content-uid="' + contentUid + '"]').each(function() {
                    //   let btn = $(this).FavoriteButton()
                    //   if (btn && btn.toggle_off) {
                    //     btn.toggle_off()
                    //   }
                    // })
                  },
                  error: function(error) {
                    closeModal()
                  },
                })
              },
              onSecondaryCta: (closeModal) => {
                // Just close the modal
                closeModal()
              }
            })
          }
        })
      },
      error: function(error) {
        /* Hide loading state on error */
        $('.wishlist-spinner').removeClass('wishlist-spinner--visible')
        $('.wishlist-list__content').removeClass('wishlist-list__content--loading')
        $('.wishlist-empty').show()
      },
    })
    return self
  }()
}

export default favorites
